import {
  Component,
  ElementRef,
  Inject,
  isDevMode,
  OnDestroy,
  OnInit,
  QueryList,
  Renderer2,
  ViewChild,
  ViewChildren,
  ViewEncapsulation,
  DOCUMENT,
  ChangeDetectionStrategy
} from '@angular/core';
import {UntypedFormArray, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {Quotation} from '../../interfaces/quotation';
import {Order} from '../../interfaces/order';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import {ApiService} from '../../services/api.service';
import {NgxSmartModalService} from 'ngx-smart-modal';
import {TranslateService} from '@ngx-translate/core';
import {filter, Observable, pairwise, Subscription} from 'rxjs';
import {DefaultPrice, Price} from '../../interfaces/price';
import {CoolLocalStorage} from '@angular-cool/storage';

import {StateService} from '../../services/state.service';
import {saveRecentPassenger} from '../../services/recent-passengers';
import {FieldErrorService} from '../../services/field-error.service';
import {FieldError} from '../../interfaces/field-error';
import {AnalyticsService, DataLayerProperties} from '../../services/analytics.service';
import {QuoteRequestContext, QuoteRequestService} from '../../services/quote-request.service';
import {Product} from '../../interfaces/product';
import {environment} from '../../../environments/environment';
import {Field} from '../../interfaces/field';
import {DomSanitizer, Title} from '@angular/platform-browser';
import {PaymentGateway, TransactionCosts, TransactionCostType} from '../../interfaces/payment-gateway';
import {VisitorService} from '../../services/visitor.service';
import {MSP_LOCALES} from '../../data/msp-locales';
import {Job} from '../../interfaces/job';
import moment from 'moment-timezone';
import Swal from 'sweetalert2';
import {CustomerService} from "../../services/customer.service";
import * as randomstring from 'randomstring';
import {PreviewRouteMapComponent} from "../preview-route-map/preview-route-map.component";
import {map, take} from "rxjs/operators";
import md5 from 'crypto-js/md5';
import {GoogleMap} from '@angular/google-maps';
import {FieldWrapperComponent} from "../field-wrapper/field-wrapper.component";
import {MatIconRegistry} from "@angular/material/icon";

const apiFormIdProvider = (route: ActivatedRoute) => {
  if (route.parent && route.parent.snapshot) {
    return route.parent.snapshot.params.formId;
  }
};

interface FieldControl {
  property: string;
  control: UntypedFormControl;
}

const getBounds = (
  polygons: google.maps.Polygon[]
): google.maps.LatLngBounds => {
  const bounds = new google.maps.LatLngBounds();
  polygons.map(p => p.getPath()
    .forEach((el, i) => bounds.extend(el)));
  return bounds;
}

@Component({
    selector: 'app-order',
    templateUrl: './order.component.html',
    encapsulation: ViewEncapsulation.Emulated,
    styleUrls: ['./order.component.scss'],
    providers: [
        {
            provide: 'apiModel',
            useValue: 'orders'
        },
        {
            provide: 'apiFormId',
            useFactory: apiFormIdProvider,
            deps: [ActivatedRoute]
        },
        ApiService, CustomerService
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OrderComponent implements OnInit, OnDestroy {
  static readonly KNOWN_NAV = new Set(['inline', 'modal', 'tab', 'scroll']);
  readonly instanceId: string;
  @ViewChild('formNavigation', {static: true}) formNavigation: ElementRef;
  @ViewChild('paymentModalIframe', {static: true}) paymentModalIframe: ElementRef;
  @ViewChild(GoogleMap, {static: false}) serviceAreaMap: GoogleMap;
  @ViewChildren(FieldWrapperComponent) wrappers: QueryList<boolean>;
  @ViewChild('supportFrame', {static: false}) supportFrame: ElementRef;
  @ViewChild('supportReportModal', {static: false}) supportReportModal: ElementRef;
  @ViewChildren('routeMap', {}) routePreviewMaps: PreviewRouteMapComponent[];
  supportCalculationData = [];
  returnTripSupportData = [];
  supportMode: string = null;
  buttonbgcolor: string = '000000';
  buttontextcolor: string = 'ffffff';
  buttontext: string = 'process_order_button';
  buttonposition: string = 'bottomRight';
  buttonstyle: string = 'rounded';
  showbreadcrumbs: boolean = true;
  showlogo: boolean = true;
  showclose: boolean = false;
  showtopbar: boolean = true;
  acceptedPrice: boolean = false;
  priceUpdateButton: any;
  widgettype: string = 'popup-widget';
  orderStatus: string;
  vatPercentage: number = 0;

  loadedScripts: any = {};
  formStyle = 'webbooker';
  formConfig = 'webbooker';
  formGroup: UntypedFormGroup;
  styleSubscription: Subscription;
  activeTab = '';
  form: any = {config: {parts: [], widgetParts: []}};
  durationConfig: any = {
    "type": "select",
    "label": "duration_field_label",
    "property": "duration",
    "helpText": "duration_count_field_help_text",
    "quotationField": true,
    "default": 1,
    "values": []
  }
  productSelectionCode = randomstring.generate();
  navigation = 'inline';
  destinationConfig: any;
  /** The destination field's own type, remembered so hiding it on the hourly tab can be undone. */
  destinationTypeBeforeHide: string;
  formChanges: Subscription;
  formId: string;
  isWidget = false;
  currentFormHash: string;
  currentForm: any;
  selectedFormIndex: number;
  quotation: Quotation;
  catchDuplicateBooking = false;
  ipAddress: string;
  ipAddressSubscription: Subscription;
  order: Order;
  orderId = '';
  products: any[] = [];
  pageStates: boolean[] = [];
  metaFields: any[] = [];
  numericFields: string[] = [];
  quotationFields: string[] = [];
  restrictProductsByLuggage = false;
  productMutations: any[] = [];
  optionSurchargeFields: any[] = [];
  helpData = {
    helpTitleTag: '',
    helpTextTag: '',
    type: 'helpModal',
    meta: null,
  };
  totalPrice = 0;
  transactionCosts = 0;
  singlePrice = 0;
  discountPrice = 0;
  singleMeta: any = {};
  singleForeignMeta: any = {};
  displayProducts: any = {};
  singleProducts: Product[] = [];
  returnPrice = 0;
  returnMeta: any = {};
  returnForeignMeta: any = {};
  returnProducts: Product[] = [];
  jobPrice: Price;
  jobPriceReturn: Price;
  formSubscription: Subscription;
  contractTypeSubscription: Subscription;
  googleApiWarningSubscription: Subscription;
  /** True while Google Maps address lookup is misconfigured for this domain; cleared when it works again. */
  googleAPIWarning = false;
  processingPayment = false;
  errorSubscription: Subscription;
  isErroneous = false;
  globalErrors: FieldError[];
  productPageIndex = 999;
  // Dedicated quote/payment page a requested quote's confirmation screen points at. See the
  // environment file's `quotePageUrl` comment — placeholder pending that page's real URL.
  quotePageUrl = environment.quotePageUrl;
  faInfoCircle = 'info-circle';
  faExclamationTriangle = 'exclamation-triangle';
  // Trip-type selector (RideBits-style first step). `useServiceSelector` is turned on by
  // MobilePopupWidgetComponent and the ?style=mobilepopup preview hook; `showServiceSelector`
  // is only flipped on when the form actually offers a choice (see _ngOnInit).
  useServiceSelector = false;
  showServiceSelector = false;
  navigationError = {title: '', text: ''};
  affiliateCode: string;
  paymentGateways: PaymentGateway[] = [];
  mspLanguage: string;
  loader = false;
  hasGoogleError = false;
  savedValues: any;
  passenger: any;
  formParts = [];
  modalFormIndex = 0;
  steps: any = [];
  changedDestinationDate = '';
  metrics: any;
  modalOpen = false;
  onlyShowLoader: boolean = false;
  selectedProducts: any;
  mapServiceAreaCenter: any;

  departureMarker: any;
  destinationMarker: any;
  googleMapsLoaded = false;
  myPolygon = null;
  serviceArea = null;
  serviceAreaError = false;
  protected readonly Math = Math;

  constructor(private apiService: ApiService,
              private activatedRoute: ActivatedRoute,
              private modalService: NgxSmartModalService,
              private translate: TranslateService,
              private _vault: CoolLocalStorage,
              private router: Router,
              private route: ActivatedRoute,
              protected state: StateService,
              private errorService: FieldErrorService,
              public analytics: AnalyticsService,
              private pageTitle: Title,
              private visitorService: VisitorService,
              private _customerService: CustomerService,
              private _renderer2: Renderer2,
              private _iconRegistry: MatIconRegistry,
              private _sanitizer: DomSanitizer,
              @Inject('Window') private window: Window,
              @Inject(DOCUMENT) public document: Document) {
    this.instanceId = `wb-${Math.random().toString(36).slice(2, 11)}`;
    this.selectedFormIndex = 0;
    this.loadAssets();
  }

  loadScript(url, callback = null) {
    if (this.loadedScripts[url]) {
      return;
    }
    const self = this;
    let script = this._renderer2.createElement('script');
    script.src = url;
    let done = false;
    script.onload = script.onreadystatechange = function () {
      if (!done && (!this.readyState ||
        this.readyState === "loaded" || this.readyState === "complete")) {
        done = true;
        if (callback) {
          self[callback]();
        }
        // Handle memory leak in IE
        script.onload = script.onreadystatechange = null;
      }
    };
    this._renderer2.appendChild(this.document.body, script);
    this.loadedScripts[url] = true;
  }

  loadAssets() {
    const iconMap: { [key: string]: string } = {
      'cash': 'cash.svg',
      'ideal': 'ideal.svg',
      'payments': 'cash.svg',
      'paypal': 'paypal.svg',
      'credit_card': 'creditcard.svg',
      'stripe': 'creditcard.svg',
      'square': 'square.svg',
      'wipay': 'wipay.svg',
      'multisafepay': 'multisafepay.svg'
    };

    const baseUrl = 'https://yourwebbooker.com/assets/icons/';

    for (const iconName in iconMap) {
      if (iconMap.hasOwnProperty(iconName)) {
        this._iconRegistry.addSvgIcon(
          iconName,
          this._sanitizer.bypassSecurityTrustResourceUrl(`${baseUrl}${iconMap[iconName]}`)
        );
      }
    }
  }

  ngOnInit(): void {
    if (this.activatedRoute && this.activatedRoute.snapshot && this.activatedRoute.parent && !this.isWidget) {
      this._ngOnInit();
    }
  }

  startGoogleMaps(apiKey) {
    const self = this;
    apiKey = (apiKey ? apiKey : "AIzaSyDQ9xFGyOnw47jqMXxgvLJ6TQXqLCeLNwg");
    if (isDevMode()) {
      apiKey = "AIzaSyDQ9xFGyOnw47jqMXxgvLJ6TQXqLCeLNwg";
    }

    // Google Maps calls this global on an auth/referer failure (e.g. the live domain is not
    // in the API key's HTTP-referrer allowlist). Without a handler the failure is silent and
    // autocomplete just returns nothing. Set a flag so the address field can show a clear
    // misconfiguration message. Works inside the inline Angular Element too (no index.html).
    if (typeof (window as any).gm_authFailure !== 'function') {
      (window as any).gm_authFailure = () => {
        self.state.googleMapsAuthError = true;
        self.state.googleMapsErrorUrl = window.location.host;
      };
    }
    // if ((window as any).dataLayer) {
    //   const dataLayer = (window as any).dataLayer || [];
    //   dataLayer.push({
    //     'gtm.start': new Date().getTime(),
    //     event: 'gtm.js'
    //   });
    // }

    if (typeof google !== 'object' || typeof google.maps !== 'object') {
      setTimeout(function () {
        let loaded = window.document.getElementById('google-map-script');
        if (!loaded) {
          let s = window.document.createElement('script');
          s.id = 'google-map-script';
          s.type = 'text/javascript';
          s.async = true;
          s.src = `https://maps.googleapis.com/maps/api/js?loading=async&who=${self.formStyle}&libraries=places,routes,maps&key=${apiKey}&language=${self.state.language}${(self.formStyle === 'inline' || self.formStyle === 'widget' ? '' : '&callback=testGoogleApi')}`;
          window.document.body.appendChild(s);
        }
      }, 50);
    } else if (!google.maps.places && typeof google.maps.importLibrary === 'function') {
      // Host page loaded Google Maps without the Places library — load it on demand.
      google.maps.importLibrary('places').catch((e: any) => console.warn('Failed to load Places library:', e));
    }
  }

  tinyAlert(message) {
    Swal.fire(message);
  }

  handleParams(params) {
    const styles = {
      colors: {}
    };
    Object.keys(params).forEach((o) => {
      if (params[o] === 'true') {
        this[o] = true;
      } else if (params[o] === 'false') {
        this[o] = false;
      } else {
        this[o] = params[o];
      }
    });

    if (this['headercolor']) {
      styles.colors['global-title-color'] = `#${this['headercolor']}`;
    }
    if (this['textcolor']) {
      styles.colors['header-text-color'] = `#${this['textcolor']}`;
      styles.colors['global-text-color'] = `#${this['textcolor']}`;
    }
    if (this['backgroundcolor']) {
      styles.colors['form-nav-background-color'] = `#${this['backgroundcolor']}`;
    }
    if (!this['showlogo']) {
      styles.colors['logo-display'] = 'none';
    } else {
      styles.colors['logo-display'] = 'block';
    }
    if (!this['showtopbar']) {
      styles.colors['header-display'] = 'none';
    } else if (this.form.config.styles && this.form.config.styles.colors && this.form.config.styles.colors['header-display']) {
      styles.colors['header-display'] = this.form.config.styles.colors['header-display'];
    } else {
      styles.colors['header-display'] = 'flex';
    }

    if (this['font']) {
      styles.colors['form-fontstyle'] = this['font'];
    }

    Object.keys(styles.colors).forEach(key => {
      if (styles.colors[key].indexOf('$') > -1) {
        this.document.documentElement.style.setProperty(`--${key}`, `var(--${styles.colors[key].replace('$', '')})`);
      } else {
        this.document.documentElement.style.setProperty(`--${key}`, styles.colors[key]);
      }
    });
  }

  _ngOnInit(initData?: any): void {
    const self = this;
    let startStep = 'step1';
    this.state.couponDiscount = null;
    if (!this.formGroup && this.state.formGroup) {
      this.formGroup = this.state.formGroup;
    }

    if (this.activatedRoute && this.activatedRoute.queryParams) {
      this.activatedRoute.queryParamMap.subscribe((params: ParamMap) => {
        // No-build preview hook: ?style=mobilepopup renders the mobile-popup widget design inside the
        // main `ng serve` app (no widget build needed). It activates the theme class and the trip-type
        // first step on the normal INLINE form. (The real <mobile-popup-widget> additionally runs in a
        // modal; the modal machinery lives in the widget subclasses, so the inline form is what we
        // preview here — the theme + first step are identical, only the modal chrome differs.)
        if (params.get('style') === 'mobilepopup') {
          this.document.documentElement.classList.add('wb-theme-mobilepopup');
          this.useServiceSelector = true;
        }

        const data = params.get('preOrder');
        let orderObject = JSON.parse(data);
        if (orderObject) {
          if (!orderObject.departureModel) {
            orderObject = JSON.parse(orderObject);
          }

          if (orderObject.activeTab) {
            self.setActivateTab(orderObject.activeTab);
            delete orderObject.activeTab;
          }

          orderObject.timesaved = moment();
          this._vault.setObject(this.state.storageKeys.values, orderObject);
          if (orderObject.navigateTo) {
            startStep = orderObject.navigateTo;
          }
        }
      });
    }

    this.errorSubscription = this.errorService.$errors.subscribe(() => {
      this.globalErrors = this.errorService.getFieldErrors('global');
      this.isErroneous = this.globalErrors.length > 0;
    });
    // this.ipAddressSubscription = this.visitorService.getIpAddress().subscribe(ip => {
    //   this.ipAddress = ip;
    // });
    let dataPointer;
    if (initData) {
      dataPointer = Observable.create(function (observer) {
        observer.next(initData);
        observer.complete();
      });
    } else {
      dataPointer = (this.activatedRoute.snapshot.params.formId ? this.activatedRoute.data : this.activatedRoute.parent.data);
    }
    this.formSubscription = dataPointer.subscribe((data: { form: any }) => {
      let paymentStatus;
      let orderId;
      if (this.activatedRoute && this.activatedRoute.parent && this.activatedRoute.snapshot) {
        paymentStatus = this.activatedRoute.snapshot.params.paymentStatus;
        orderId = this.activatedRoute.snapshot.params.orderId ?
          this.activatedRoute.snapshot.params.orderId :
          this.activatedRoute.parent.snapshot.params.orderId;
      }

      if (orderId) {
        this.orderId = orderId;
      }

      // if (this._vault.getItem(this.state.storageKeys.paymentStarted) === '1' && paymentStatus !== 'completed') {
      //   this.state.reset();
      // }

      this.form = data.form;
      this.formParts = (this.navigation !== 'modal' ? this.form.config.parts : [this.form.config.parts[0]]);
      this.formId = data.form.id;

      const supportHash = this.route.snapshot.paramMap.get('hash');
      if (supportHash) {
        const testHash = md5(`billyJeans_${new Date('Y-m-d')}_${(data.form.config.customUrl ? data.form.config.customUrl : data.form.id)}`);
        if (supportHash === testHash.toString()) {
          this.supportMode = supportHash;
        }
      }
      this.passenger = JSON.parse(this._vault.getItem(`#t-#${this.form.id}-user`) || '{}');

      this.loadSavedValues();
      this.state.formParts = this.preProcessParts(this.form.config.parts);

      this.startGoogleMaps(this.state.googleApiKey);

      this.steps = this.form.config.parts.filter((p) => {
        return (!p.hideFromSteps)
      });

      const onlinePaymentIds = ['STRIPE', 'SQUARE', 'PAYPAL', 'WIPAY', 'MULTISAFEPAY'];
      const hasOnlinePayment = this.form.config.payment?.gateways?.some(
        g => onlinePaymentIds.includes(g.id)
      );
      if (!hasOnlinePayment) {
        this.steps = this.steps.map(step =>
          step.title === 'form_tab_4_title' ? { ...step, title: 'form_tab_4_title_no_payment' } : step
        );
      }
      if (!this.form.config.widgetParts) {
        this.form.config.widgetParts = JSON.parse(JSON.stringify([this.form.config.parts[0]]));
        this.form.config.widgetParts[0].fields = this.form.config.parts[0].fields.filter((item, i) => {
          return (i < 3);
        });
        this.form.config.length = 1;
      }

      if (this.formConfig === 'widget') {
        this.form.config.parts = Object.assign(this.form.config.parts, this.form.config.widgetParts);
      }

      if (this.form.config.hourlyBookings) {
        for (let x = (this.form.config.hourlyMinTime > 0 ? this.form.config.hourlyMinTime : 1); x < (this.form.config.hourlyMaxTime > 0 ? (this.form.config.hourlyMaxTime + 1) : 25); x++) {
          this.durationConfig.values.push({
            "value": x,
            "label": (x === 1 ? "hours_field_value_singular" : "hours_field_value_multi")
          });
        }

        this.durationConfig.default = (this.form.config.hourlyMinTime > 0 ? this.form.config.hourlyMinTime : 1);
      }

      // Only the standalone app has <link id="app-favicon"> (src/index.html). An embedded widget has no
      // such element on the host page, and the old unguarded lookup threw here and aborted the whole
      // form setup. Never touch an embedding site's favicon either.
      const faviconLink = this.form.config.favicon ? this.document.getElementById('app-favicon') : null;
      if (faviconLink) {
        faviconLink.setAttribute('href', this.form.config.favicon);
      }

      if (self.formStyle !== 'inline') {
        if (this.form.config.pageTitle) {
          this.pageTitle.setTitle(this.form.config.pageTitle);
        } else {
          this.pageTitle.setTitle(this.form.name);
        }
      }

      if (this.formStyle === 'webbooker') {
        this.createGTM();
      }

      this.createUmami();

      if (paymentStatus === 'completed') {
        this.processingPayment = true;
        this.waitForPayment();
      }

      if (this.activatedRoute.snapshot.paramMap.get('showtopbar')) {
        this.handleParams(this.activatedRoute.snapshot.params);
      } else if ((!this.form.config.styles || !this.form.config.styles.colors || !this.form.config.styles.colors['header-display']) && this.showtopbar) {
        /**
         * We start with none, for cleaning loading of the form
         */
        this.document.documentElement.style.setProperty(`--header-display`, `flex`);
      }

      for (const part of this.form.config.parts) {
        for (const field of part.fields) {
          if (part.fields) {
            part.fields = part.fields.filter((field) => {
              return (field.property !== 'acceptTermsAndConditions' || field.documentUrls?.filter((docUrl) => docUrl !== '').length > 0);
            });
          }
        }
      }

      this.setup();
      this.getPaymentGateways();

      for (const part of this.form.config.parts) {
        part.fieldsWithLayoutInfo = [];
        let halfIndex = 1;
        let thirdIndex = 1;

        if(part.fields) {
          for (const field of part.fields) {
            const css = field.cssclass || '';
            const isHalf = css.includes('wb-half-width');
            const isThird = css.includes('wb-third-width');

            if(isHalf) {
              thirdIndex = 1;
            }
            if(isThird) {
              halfIndex = 1;
            }

            field.halfIndex = isHalf ? halfIndex++ : null;
            field.thirdIndex = isThird ? thirdIndex++ : null;
            part.fieldsWithLayoutInfo.push(field);
          }
        }
      }

      if (this.state.forcedRequestedDateMode) {
        this.formGroup.controls['requestedDateMode'].setValue(this.state.forcedRequestedDateMode);
        this.formGroup.controls['returnRequestedDateMode'].setValue(this.getDateMode(true));
      } else {
        this.formGroup.controls['requestedDateMode'].setValue(this.getDateMode());
        this.formGroup.controls['returnRequestedDateMode'].setValue(this.getDateMode(true));
      }
      this.setCorrectDateField(this.formGroup.controls['requestedDateMode'].value, this.formGroup.controls['returnRequestedDateMode'].value);

      // this.formGroup.valueChanges.subscribe(this._onChanges.bind(this));
      this.formGroup.valueChanges.pipe(
        pairwise(),
        map(([oldState, newState]) => {
          let changes = {};
          for (const key in newState) {
            if (oldState[key] !== newState[key] &&
              oldState[key] !== undefined) {
              changes[key] = newState[key];
            }
          }
          return changes;
        }),
        filter(changes => Object.keys(changes).length !== 0)
      ).subscribe(
        changes => {
          this._onChanges(changes);
        }
      );

      // GTM still gets the step-0 virtual page view, but Umami does NOT: showing page 1
      // is the start of the funnel (`form_loaded`), not a completion. The first Umami
      // funnel event is `address_completed`, fired when the user leaves this step.
      this.analytics.pageView(`/${this.state.language}/${this.form.id}/${this.form.config.parts[0].gtmVirtualPageUrl}`,
        undefined, true, this.analyticsContext({ step: this.form.config.parts[0]?.gtmVirtualPageUrl, stepIndex: 0 }));
      this.activeTab = '';
      this.activateTab((this.form.config.routeBookings ? 'route' : 'hourly'));

      // Show the RideBits-style trip-type selector first, but only when the form offers a real
      // choice of trip modes (otherwise there is nothing to choose and we go straight to the form).
      this.showServiceSelector = this.useServiceSelector && this.serviceTypes.length > 1;

      if (startStep === 'step2') {
        this.navigate('next');
      }

      this.detectGoogleMapsLoaded();

      this.contractTypeSubscription?.unsubscribe();
      this.contractTypeSubscription = this.state.contractType$.pipe(
        filter(type => type !== null),
        take(1)
      ).subscribe(type => {
        if (type === 'webbooker_free') {
          this.applyFreePlanOverrides();
        }
      });

      // Reflect a Google Maps address-lookup misconfiguration on the form: set when the
      // address field detects an auth/referer error, cleared when autocomplete works again.
      //
      // Seed the in-memory flag from the form's persisted state (`config.googleAutocompleteIssue`)
      // so a form that was previously flagged but is now fixed produces a real true→false
      // transition on the first successful autocomplete, and the stored flag is cleared (DELETE).
      // Without seeding, the in-memory flag starts false, so clearing it on success is a no-op and
      // the persisted flag would never be removed. `googleAPIWarning` is set to the same value so
      // the seed itself is not reported back (no redundant POST for an already-stored flag).
      const persistedAutocompleteIssue = !!this.form?.config?.googleAutocompleteIssue;
      this.googleAPIWarning = persistedAutocompleteIssue;
      this.state.googleMapsAuthError = persistedAutocompleteIssue;

      this.googleApiWarningSubscription?.unsubscribe();
      this.googleApiWarningSubscription = this.state.googleMapsAuthError$.subscribe((hasError) => {
        if (hasError === this.googleAPIWarning) {
          return; // no transition (e.g. the initial replay / seeded value) — nothing to report
        }
        this.googleAPIWarning = hasError;
        this.onGoogleAPIWarningChange(hasError);
      });
    });
  }

  /**
   * Persists the Google Maps address-lookup misconfiguration on the form, so the portal can
   * show the operator how to fix it. Fires once per transition: detected → POST (set the
   * `googleAutocompleteIssue` flag), resolved → DELETE (clear it). The form is authenticated
   * by the form-scoped JWT the AuthInterceptor derives from the `X-Form-Id` header, which
   * satisfies the endpoints' `requireOwnedForm` check.
   */
  private onGoogleAPIWarningChange(hasError: boolean): void {
    const formId = this.state.formId;
    if (!formId) {
      return;
    }
    const path = `/forms/${formId}/google-autocomplete-issue`;
    const request = hasError
      ? this.apiService.postCustom(path, {})
      : this.apiService.deleteCustom(path);
    request.subscribe({
      next: () => {},
      error: (e) => console.warn('Failed to report Google autocomplete issue:', e),
    });
  }

  /** Webbookers created/saved by the taxiID portal carry `config.poweredByBrand: 'taxiid'`. */
  get isTaxiIdBranded(): boolean {
    return this.form?.config?.poweredByBrand === 'taxiid';
  }

  get showPoweredBy(): boolean {
    return !!this.form?.config?.poweredBy;
  }

  get poweredByHref(): string {
    return this.isTaxiIdBranded ? 'https://www.taxiid.nl' : 'https://www.taxiwebbooker.com';
  }

  get poweredByBrandName(): string {
    return this.isTaxiIdBranded ? 'taxiID' : 'TaxiWebBooker.com';
  }

  /** `config.supportLink`, only when it is an https/http/mailto URL (never `javascript:` etc.). */
  get supportLinkUrl(): string | null {
    const link = this.form?.config?.supportLink;
    if (typeof link !== 'string') {
      return null;
    }
    const trimmed = link.trim();
    return /^(https?:\/\/|mailto:)\S+$/i.test(trimmed) ? trimmed : null;
  }

  private applyFreePlanOverrides(): void {
    // Hide login link
    this.form.config.passengerLogin = false;

    // No stopovers (neither booking type)
    this.form.config.allowStopOvers = false;
    this.form.config.allowStopOversRoute = false;
    this.form.config.allowStopOversHourly = false;

    // No hourly bookings
    this.form.config.hourlyBookings = false;
    if (this.activeTab === 'hourly') {
      this.activateTab('route');
    } else {
      // activateTab() early-returns when the tab is already active, so drop any stopover the
      // form was carrying before the plan was known here instead.
      this.clearStopOversIfDisallowed(this.activeTab);
    }

    // Always show poweredBy — legacy TaxiWebBooker forms only. Forms written by the taxiID portal
    // (`poweredByBrand === 'taxiid'`) honour `config.poweredBy`; the portal decides who may hide it.
    if (!this.isTaxiIdBranded) {
      this.form.config.poweredBy = true;
    }

    // No custom (collapse) fields
    for (const part of this.form.config.parts) {
      if (part.fields) {
        part.fields = part.fields.map((f: Field) =>
          f.type === 'collapse' ? { ...f, hidden: true } : f
        );
      }
      if (part.fieldsWithLayoutInfo) {
        part.fieldsWithLayoutInfo = part.fieldsWithLayoutInfo.map((f: Field) =>
          f.type === 'collapse' ? { ...f, hidden: true } : f
        );
      }
    }

    // No Stripe / Square / Multisafepay / Paypal
    const blockedGateways = ['STRIPE', 'SQUARE', 'MULTISAFEPAY', 'PAYPAL'];
    this.form.config.payment.gateways = this.form.config.payment.gateways.filter(
      (g: PaymentGateway) => !blockedGateways.includes(g.id.toUpperCase())
    );
    this.getPaymentGateways();
  }

  createGTM(): void {
    if (this.form.config.gtmId && !isDevMode()) {
      const position = this.document.getElementsByTagName('script')[0];
      const script = this.document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtm.js?ydaLoaded=true&id=${this.form.config.gtmId}`;
      position.parentNode.insertBefore(script, position);
      const noScriptIframeContainer = this.document.getElementById('gtm-no-script');
      const noScriptIframe = this.document.createElement('iframe');
      noScriptIframe.src = `https://www.googletagmanager.com/ns.html?id=${this.form.config.gtmId}`;
      noScriptIframe.setAttribute('height', '0');
      noScriptIframe.setAttribute('width', '0');
      noScriptIframe.setAttribute('style', 'display:none;visibility:hidden');
      noScriptIframeContainer.appendChild(noScriptIframe);
    }
  }

  /**
   * The loaded integration as a short implementation name, for analytics:
   * 'popup' / 'mobile-popup' (floating widgets), 'inline' (inline Angular Element),
   * 'iframe' (standalone booker embedded in an iframe), or 'standalone' (hosted booker).
   */
  getImplementation(): string {
    if (this.formStyle === 'widget') {
      return this.widgettype === 'mobile-popup-widget' ? 'mobile-popup' : 'popup';
    }
    if (this.isWidget) {
      return 'inline';
    }
    try {
      if (this.window && this.window.self !== this.window.top) {
        return 'iframe';
      }
    } catch (e) {
      // Accessing window.top across origins throws — that only happens when framed.
      return 'iframe';
    }
    return 'standalone';
  }

  /**
   * Non-PII booking context attached to Umami events. Deliberately EXCLUDES
   * passenger name/email/phone — Umami stays PII-free. Best-effort: every field is
   * guarded and undefined/empty values are stripped. `extra` is merged on top.
   */
  analyticsContext(extra: Record<string, any> = {}): Record<string, any> {
    const ctx: Record<string, any> = {
      implementation: this.getImplementation(),
      formId: this.form?.id,
      language: this.state?.language,
      tripType: this.activeTab,
    };
    try {
      if (this.formGroup) {
        ctx.returnTrip = !!this.formGroup.controls['returnTrip']?.value;
        const product = this.formGroup.controls['product']?.value;
        if (product) {
          ctx.vehicleType = product.sku || product.name;
        }
      }
      const q = this.quotation as any;
      if (q) {
        if (q.departure?.internationalAlias) ctx.departure = q.departure.internationalAlias;
        if (q.destination?.internationalAlias) ctx.destination = q.destination.internationalAlias;
        if (q.passengerCount != null) ctx.passengers = q.passengerCount;
        if (q.requestedDate) ctx.requestedDate = q.requestedDate;
      }
      if (this.totalPrice) ctx.price = this.totalPrice / 100;
      if (this.state?.currency) ctx.currency = this.state.currency;
    } catch (e) {
      // context is best-effort; never let analytics break the booking flow
    }
    Object.keys(ctx).forEach(k => (ctx[k] === undefined || ctx[k] === '') && delete ctx[k]);
    return { ...ctx, ...extra };
  }

  /**
   * Fire the Umami `<step>_loaded` funnel event when the user ARRIVES at a wizard
   * step (forward navigation only). The step name is the server-configured
   * gtmVirtualPageUrl, so a typical happy flow chains:
   *   form_loaded -> product_selection_loaded -> return_trip_loaded
   *   -> personal_details_loaded -> summary_loaded -> booking_completed
   *
   * Skipped for step 0 (already covered by `form_loaded` on load / modal-open) and
   * for the terminal completion step (covered by `booking_completed` from
   * ConfirmationComponent), so neither is double-counted.
   */
  emitStepLoaded(index: number): void {
    const part = this.form?.config?.parts?.[index];
    if (!part || !part.gtmVirtualPageUrl) { return; }
    if (index === 0 || part.type === 'completion') { return; }
    this.analytics.umamiEvent(`${part.gtmVirtualPageUrl}_loaded`,
      this.analyticsContext({ step: part.gtmVirtualPageUrl, stepIndex: index }));
  }

  createUmami(): void {
    // Unlike GTM, Umami is injected in all builds (including dev) — no isDevMode() guard by design.
    if (this.form?.config?.umamiWebsiteId && !this.document.getElementById('umami-script')) {
      const script = this.document.createElement('script');
      script.id = 'umami-script';
      script.defer = true;
      // Serve the tracker SCRIPT from yourwebbooker.com (the widget's own host, already in
      // the embedding page's CSP script-src) — umani.taxiwebbooker.com is not in their
      // script-src, so loading script.js from there is blocked. Events, however, go DIRECTLY
      // to Umami's native endpoint via data-host-url: a fetch POST is governed by connect-src,
      // which these pages don't enforce (the form already calls order.dispatchapi.io without
      // it being allowlisted). So no reverse-proxy is needed and no extra CSP entry is required.
      script.src = 'https://yourwebbooker.com/umami/script.js';
      script.setAttribute('data-website-id', this.form.config.umamiWebsiteId);
      script.setAttribute('data-host-url', 'https://umami.taxiwebbooker.com');
      // Disable Umami's automatic pageview tracking. The booking wizard is a single
      // virtual page (no real URL changes), so auto-track would only emit one noisy
      // raw-URL pageview on load (e.g. /nl/{formId}) that the funnel can't use. The
      // funnel is driven entirely by our explicit named events (form_loaded,
      // product_selection_loaded, …, booking_completed) instead.
      script.setAttribute('data-auto-track', 'false');
      // The script loads with defer, so umami is not yet available when the
      // form-load pageView() fires synchronously below. Send the load page view to
      // Umami once the script is ready so the funnel starts correctly. Fixed names
      // (not the lang/formId/step path) so they aggregate across forms/languages.
      //
      // For the floating/popup widget (formStyle === 'widget') the script loads when the
      // widget mounts (the docked button appears), not when the booking form opens —
      // record that as `widget_loaded`. The actual form-open (`form_loaded`) is fired
      // separately when the user clicks the button to open the modal (see navigate() in
      // the widget). Inline and iframe/standalone styles show the form immediately, so the
      // load IS the form load (`form_loaded`) — they do NOT emit a `widget_loaded`.
      script.onload = () => {
        // Dress the load event with the implementation (standalone/iframe/inline/popup/
        // mobile-popup) + form/language context so loads can be broken down by integration.
        this.analytics.umamiPageView(
          this.formStyle === 'widget' ? 'widget_loaded' : 'form_loaded',
          this.analyticsContext()
        );
        // Also register a real Umami pageview so the portal's website-traffic
        // panel counts this load. The named event above is event-type only and
        // does not register as a visitor in Umami's pageview-based /stats.
        this.analytics.umamiVisit();
      };
      this.document.body.appendChild(script);
      console.log('Umami tracking script added for website id:', this.form.config.umamiWebsiteId);
    }
  }

  createControl(field): FieldControl[] {
    const controls: FieldControl[] = [];
    let value = this.savedValues[`${field.property}`] ?
      this.savedValues[`${field.property}`] :
      typeof field.default !== 'undefined' ?
        field.default :
        (field.type === 'select' ? field.values[0].value : '');

    if (field.type === 'number') {
      value = this.savedValues[field.property] ? this.savedValues[field.property] : (field.min || 0);
      controls.push({
        property: field.property,
        control: new UntypedFormControl(value),
      });
    } else if (field.type === 'address') {
      const modelValue = this.savedValues[`${field.property}Model`] ? this.savedValues[`${field.property}Model`] : null;
      controls.push({
        property: `${field.property}Model`,
        control: new UntypedFormControl(modelValue),
      });
      controls.push({
        property: field.property,
        control: new UntypedFormControl(value),
      });
    } else if (field.type === 'dateTime') {
      let defaultValue = 'requestedDate';
      const modeValue = this.savedValues[`${field.property}Mode`] ? this.savedValues[`${field.property}Mode`] : defaultValue;
      if (field.property === 'requestedDate' || field.property === 'returnRequestedDate') {
        controls.push({
          property: `${field.property}Mode`,
          control: new UntypedFormControl(field.property),
        });
      }

      controls.push({
        property: field.property,
        control: new UntypedFormControl(value),
      });
    } else if (field.type === 'phone') {
      controls.push({
        property: field.property,
        control: new UntypedFormControl(value),
      });
      controls.push({
        property: field.property + 'Country',
        control: new UntypedFormControl(this.savedValues[`${field.property}Country`]),
      });
      controls.push({
        property: 'smsAuthorization',
        control: new UntypedFormControl(value),
      });
    } else {
      controls.push({
        property: field.property,
        control: new UntypedFormControl(value),
      });
    }
    return controls;
  }

  specialSetup(field: Field, index: number) {
    if(!field.meta && !field.foreignMeta && field.id) {
      field.foreignMeta = true;
    }
    if (field.meta || field.foreignMeta) {
      this.metaFields.push(field);
    }
    if (field.numeric) {
      this.numericFields.push(field.property);
    }
    if (field.product) {
      this.productMutations.push({
        id: field.id,
        property: field.property,
        label: field.label,
        type: field.type,
        values: field.values,
        showIf: field.showIf,
        mutation: field.product
      });
    }
    if (field.type === 'select' && field.values &&
      field.values.some((v: any) => v.calculatedCosts || v.calculatedCostsReturn)) {
      this.optionSurchargeFields.push(field);
    }
    if (field.quotation) {
      this.quotationFields.push(field.property);
    }
    if (field.property === 'luggage') {
      const raw: any = (field as any).restrictProductsByLuggage;
      this.restrictProductsByLuggage = raw === true || raw === 'true';
    }

    if (!this.form.config.parts[index].requirements) {
      this.form.config.parts[index].requirements = [];
    }
    if (field.required) {
      this.form.config.parts[index].requirements.push(field);
    }

    if (field.type === 'address') {
      if (field.property === 'departure') {
        this.state.returnDepartureField = {...field, property: 'destination'};
      } else if (field.property === 'destination') {
        this.state.returnDestinationField = {...field, property: 'departure'};
      }
    }
  }

  getDateMode(returnDate = false): string {
    let mode = 'requestedDate';
    // console.log(this.state.orderMode);
    // console.log(this.form.config.airportDates);
    if (!returnDate) {
      if (this.state.orderMode === 'airport' && this.form.config.airportDates !== 'none') {
        if (this.form.config.airportDates === 'departure' || this.form.config.airportDates === 'destination') {
          if (this.state.airportDeparture && this.form.config.airportDates === 'departure') {
            mode = 'requestedScheduleDate'
          } else if (this.state.airportDestination && this.form.config.airportDates === 'destination') {
            mode = 'requestedScheduleDate'
          }
        } else if (this.state.airportDeparture) {
          mode = 'requestedScheduleDate'
        } else if (this.state.airportDestination) {
          mode = 'requestedDestinationDate'
        }
      }
    } else {
      mode = 'returnRequestedDate';
      if (this.state.orderMode === 'airport' && this.form.config.airportDates !== 'none')
        if (this.form.config.airportDates === 'departure' || this.form.config.airportDates === 'destination') {
          if (this.state.airportDestination && this.form.config.airportDates === 'departure') {
            mode = 'returnRequestedScheduleDate'
          } else if (this.state.airportDeparture && this.form.config.airportDates === 'destination') {
            mode = 'returnRequestedScheduleDate'
          }
        } else if (this.state.airportDestination) {
          mode = 'returnRequestedScheduleDate'
        } else if (this.state.airportDeparture) {
          mode = 'returnRequestedDestinationDate'
        }
    }
    return mode;
  }

  setCorrectDateField(requestedDateMode, returnRequestedDateMode) {
    /**
     * Hide all date fields in config parts[0] and parts[1] that are not requestedDateMode
     */
    this.form.config.parts[0].fields = this.form.config.parts[0].fields.map((f) => {
      /**
       * For fields that are dateTime type and not requestedDateMode set hidden to true
       */
      if (f.type === 'dateTime') {
        if (f.property !== requestedDateMode) {
          // console.log("Hidden--" + f.property + "!==" + this.formGroup.controls['requestedDateMode'].value);
          f.hidden = true;
        } else {
          f.hidden = false;
          // console.log("Visible--" + f.property + "!==" + this.formGroup.controls['requestedDateMode'].value);
        }
      }
      return f;
    });

    this.form.config.parts[1].fields = this.form.config.parts[1].fields.map((f) => {
      /**
       * For fields that are dateTime type and not requestedDateMode set hidden to true
       */
      // console.log(returnRequestedDateMode);
      if (f.type === 'dateTime') {
        let mode =
          this.formGroup.controls['returnRequestedDateMode'].value.replace('returnR', 'r');
        const returnMode = mode.replace('requested', 'returnRequested');
        if (f.property !== returnMode) {
          // console.log("Hidden--" + f.property + "!==" + returnMode);
          f.hidden = true;
        } else {
          // console.log("Visible--" + f.property + "!==" + returnMode);
          f.hidden = false;
        }
      }
      return f;
    });
  }

  loadSavedValues() {
    if (!this.savedValues) {
      this.savedValues = JSON.parse(this._vault.getItem(this.state.storageKeys.values) || '{}');

      if (this.savedValues && !this.savedValues.timesaved) {
        try {
          this.savedValues = JSON.parse(this.savedValues);
        } catch (e) {
        }
      }

      if (!this.savedValues || !this.savedValues.timesaved || moment(this.savedValues.timesaved).isBefore(moment().subtract('1', 'hour'))) {
        this.savedValues = {};
      }
    }
    try {
      const retainedRaw = window.sessionStorage.getItem('wb-retain-customer');
      if (retainedRaw) {
        const retained = JSON.parse(retainedRaw);
        if (!this.savedValues) {
          this.savedValues = {};
        }
        this.savedValues = Object.assign({}, this.savedValues, retained);
        window.sessionStorage.removeItem('wb-retain-customer');
      }
    } catch (_) {}
    if (this.passenger) {
      if (!this.savedValues) {
        this.savedValues = {};
      }
      this.savedValues = Object.assign({}, this.savedValues, this.passenger);
    }
    if (this.savedValues['requestedDateMode'] && this.form.config.airportDates === 'none') {
      this.state.forcedRequestedDateMode = this.savedValues['requestedDateMode'];
    }
  }

  preProcessParts(parts: any[]) {
    const newFields = [], newFields2 = [];
    parts[0].fields.forEach((field, i) => {
      newFields.push(field);

      if (field.type === 'dateTime' && this.form.config.airportDates !== 'none') {
        let nField = JSON.parse(JSON.stringify(field));
        nField.property = 'requestedDestinationDate';
        nField.control = new UntypedFormControl(this.savedValues[nField.property] || '');
        nField.label = 'requested_destination_date_airport_field_label';
        nField.required = false;
        // nField.hidden = true;
        newFields.push(nField);
      }
      if (field.type === 'dateTime' && this.form.config.airportDates !== 'none') {
        let nField = JSON.parse(JSON.stringify(field));
        nField.property = 'requestedScheduleDate';
        nField.control = new UntypedFormControl(this.savedValues[nField.property] || '');
        nField.label = 'requested_schedule_date_airport_field_label';
        nField.required = false;
        // nField.hidden = true;
        newFields.push(nField);
      }
    });

    parts[1].fields.forEach((field, i) => {
      newFields2.push(field);
      if (field.type === 'dateTime' && this.form.config.airportDates !== 'none') {
        let nField2 = JSON.parse(JSON.stringify(field));
        nField2.property = 'returnRequestedDestinationDate';
        nField2.control = new UntypedFormControl(this.savedValues[nField2.property] || '');
        nField2.label = 'requested_destination_date_airport_field_label';
        nField2.required = false;
        // nField2.hidden = true;
        newFields2.push(nField2);
      }

      if (field.type === 'dateTime' && this.form.config.airportDates !== 'none') {
        let nField2 = JSON.parse(JSON.stringify(field));
        nField2.property = 'returnRequestedScheduleDate';
        nField2.control = new UntypedFormControl(this.savedValues[nField2.property] || '');
        nField2.label = 'requested_schedule_date_airport_field_label';
        nField2.required = false;
        // nField2.hidden = true;
        newFields2.push(nField2);
      }
    });

    parts[0].fields = newFields;
    parts[1].fields = newFields2;
    return parts;
  }

  toggleSMSAuthorizationRequirement(requestAuthorization): void {
    const lastStep = this.form.config.parts.length - 2;
    if (this.form.config.parts[lastStep]) {
      const hasCheckBox = this.form.config.parts[lastStep].fields.filter((field) => {
        return field.property === 'smsAuthorization'
      })[0];
      if (!hasCheckBox && requestAuthorization) {
        const nField = {
          type: 'checkbox',
          property: 'smsAuthorization',
          label: 'request_sms_authorization_title',
          placeholder: 'request_sms_authorization',
          meta: true,
          required: false,
          default: true,
          opened: true,
        };
        this.form.config.parts[lastStep].fields.push(nField);
      } else if (hasCheckBox && !requestAuthorization) {
        this.form.config.parts[lastStep].fields = this.form.config.parts[lastStep].fields.filter((field) => {
          return field.property !== 'smsAuthorization'
        });
      }
    }
  }

  /**
   * Stopovers are configurable per booking type: `allowStopOversRoute` for address (route)
   * bookings and `allowStopOversHourly` for hourly bookings. Older form configs only carry
   * the single `allowStopOvers` flag, so each per-type key falls back to it when it is absent
   * — a config written before this setting existed keeps behaving exactly as before.
   *
   * The resolved booleans are written back onto the config so every consumer (field-wrapper,
   * sortable-address-field, activateTab) reads a plain boolean instead of repeating the
   * fallback. `allowStopOvers` itself is kept meaningful as "stopovers on at least one type".
   */
  private normaliseStopOverSettings(): void {
    const config = this.form.config;
    const legacy = !!config.allowStopOvers;
    const resolve = (value: any) => (value === undefined || value === null ? legacy : !!value);

    config.allowStopOversRoute = resolve(config.allowStopOversRoute);
    config.allowStopOversHourly = resolve(config.allowStopOversHourly);
    config.allowStopOvers = config.allowStopOversRoute || config.allowStopOversHourly;
  }

  /**
   * The stopovers that may actually be sent: none at all when the active booking type has
   * stopovers turned off, and never an added-but-unfilled row (a real address always carries
   * `.gps`, while a seeded or cleared row keeps `[]`/`null`).
   *
   * The tab check is the payload-level safety net for rows that were entered on the other
   * booking type, or restored from a saved booking made before the setting was turned off —
   * the rows are cleared from the form on a tab switch, but this is the guarantee.
   */
  // Returns `any` rather than `any[]`: `Quotation.stopOvers` is declared as the tuple type
  // `[Address]`, which an `any[]` is not assignable to.
  private sendableStopOvers(values: any): any {
    if (!this.stopOversAllowedOn(this.activeTab)) {
      return [];
    }
    return (values.stopOversModel || []).filter(stopOver => stopOver && stopOver.gps);
  }

  /**
   * Empties the stopover arrays when the given booking type has stopovers turned off, so rows
   * entered on the other type — or restored from a saved booking made before the setting was
   * changed — cannot stay in the form. This runs for the *settled* tab: it is called from
   * activateTab(), which is what the deferred `preOrder` restore goes through, so it cannot
   * race the restore the way a check in the address component's ngOnInit would.
   */
  private clearStopOversIfDisallowed(tab: string): void {
    if (this.stopOversAllowedOn(tab) || !this.formGroup) {
      return;
    }
    ['stopOvers', 'stopOversModel'].forEach(name => {
      const array = this.formGroup.controls[name] as UntypedFormArray;
      if (array && array.length) {
        array.clear();
      }
    });
  }

  /**
   * Whether stopovers may be added on the given booking tab ('hourly' or 'route').
   */
  stopOversAllowedOn(tab: string): boolean {
    return !!(tab === 'hourly'
      ? this.form.config.allowStopOversHourly
      : this.form.config.allowStopOversRoute);
  }

  setup(): void {
    this.normaliseStopOverSettings();

    const controls: any = {
      product: new UntypedFormControl(null),
      returnTrip: new UntypedFormControl(false),
    };
    let addressIndex = 0;

    this.form.config.parts[0].fields.forEach((field, i) => {
      if (field.type === 'address' || field.type === 'sortableAddress') {
        addressIndex = i;
      }
    });
    if (this.state.companySettings.hasOwnProperty('orderTimesHandler')) {
      this.form.config.orderTimesHandler = this.state.companySettings.orderTimesHandler;
    }

    if (this.form.config.hourlyBookings) {
      /**
       * We add this now, so it is added to the controls, but we remove/leave it based on the active tab
       */
      this.destinationConfig = this.form.config.parts[0].fields[addressIndex];
      this.form.config.parts[0].fields.splice(addressIndex + 1, 0, this.durationConfig);
    }

    this.form.config.parts.forEach((part, index) => {
      if (part.type === 'products') {
        this.productPageIndex = index;
      }
      if (part.fields) {
        part.fields.forEach(field => {
          const subFields = field.fields;
          this.specialSetup(field, index);

          const fieldControls = this.createControl(field);
          fieldControls.forEach((fc: FieldControl) => {
            controls[fc.property] = fc.control;

            if (part.type === 'address') {
              controls[`${fc.property}Modal`] = fc.control;
            }
          });

          if (subFields) {
            subFields.forEach(subField => {
              this.specialSetup(subField, index);
              const subFieldControls = this.createControl(subField);
              subFieldControls.forEach((fc: FieldControl) => {
                controls[fc.property] = fc.control;
              });
            });
          }
        });
      }
    });

    const parts = this.form.config.parts;

// find target (products) step
    const productPart = parts.find(p => p.type === 'products');
    const firstPart = parts[0];

// safety check
    if (firstPart && productPart) {
      const airportFields = firstPart.fields.filter(
        f =>
          f.product &&
          (f.product.type === 'airportDepartureJob' ||
            f.product.type === 'airportDestinationJob')
      );

      if (airportFields.length) {
        // shallow copy to avoid mutations
        productPart.fields.push(...airportFields.map(f => ({ ...f })));
      }
    }

    // if (this.form.config.routeBookings && this.form.config.hourlyBookings) {
    //   if (!this.form.config.bookingHourlyDestination && !this.form.config.routeBookings) {
    //     this.form.config.parts[0].fields.splice((addressIndex), 1);
    //   } else if (!this.form.config.routeBookings) {
    //     this.form.config.parts[0].fields.splice((addressIndex + 1), 1);
    //   }
    // }
    /**
     * Add completed and canceled config parts as defaults add the end
     */
    if (this.form.config.parts && this.form.config.parts[this.form.config.parts.length - 1].type !== 'completion') {
      this.form.config.parts.push({
        "type": "completion",
        "title": "completed",
        "hideFromSteps": true,
        "gtmVirtualPageUrl": "booking_completed"
      });
    }

    // if(this.formConfig !== 'widget') {
    // this.preFillFieldsForTesting(controls, 3, false);
    // }

    controls.stopOvers = new UntypedFormArray([]);
    controls.stopOversModel = new UntypedFormArray([]);

    if (this.savedValues.stopOvers) {
      this.savedValues.stopOvers.forEach((stopOver, i) => {
        controls.stopOvers.push(new UntypedFormControl(stopOver));
      });
      this.savedValues.stopOversModel.forEach((stopOver, i) => {
        controls.stopOversModel.push(new UntypedFormControl(stopOver));
      });
    }

    const group = new UntypedFormGroup(controls);
    this.formGroup = group;
    this.state.formGroup = group;

    if (this.form.config.allowStopOvers || true) {
      /**
       * Replace addresses in first part for sortable-address-field
       */
      // this.form.config.parts[0].fields.splice(0,2);
      this.form.config.parts[0].fields[0].type = 'hiddenInputAddress';
      this.form.config.parts[0].fields[0].hidden = true;
      this.form.config.parts[0].fields[1].hidden = true;
      this.form.config.parts[0].fields[1].type = 'hiddenInputAddress';
      this.form.config.parts[0].fields.unshift({
        "type": "sortable-address",
        "property": "stopOvers",
        "label": "sortable-address",
        "opened": true
      });
      let b = this.form.config.parts[0].fields[0];
      this.form.config.parts[0].fields[0] = this.form.config.parts[0].fields[1];
      this.form.config.parts[0].fields[1] = b;
    }
    this.form.config.orderType = this.activeTab;

    if (this.form.config.defaults) {
      Object.keys(this.form.config.defaults).forEach(key => {
        const value = (this.form.config.defaults as any)[key];
        controls[key].setValue(value);
      });
    }

    if (this.savedValues) {
      this._onChanges(this.savedValues);
    }
  }

  canShowNextButton(navButton?: string): boolean {
    let productPage = (this.selectedFormIndex === this.productPageIndex);
    let normalPage = !productPage && this.selectedFormIndex < (this.form.config.parts.length - 2);
    if (this.navigation === 'modal') {
      productPage = (this.modalFormIndex === this.productPageIndex);
      normalPage = !productPage && this.modalFormIndex < (this.form.config.parts.length - 2);

      const productPageReturnTrip = productPage && this.formGroup.controls.returnTrip.value;
      return ((productPageReturnTrip || normalPage) && (this.modalFormIndex === 0 || navButton === 'modal'));
    } else {
      const productPageReturnTrip = productPage && this.formGroup.controls.returnTrip.value;
      return (productPageReturnTrip || normalPage);
    }
  }

  preFillFieldsForTesting(controls: any, index: number = 0, returnTrip: boolean = false): void {
    if (!environment.production) {

      // this.orderStatus = 'failed'
      // this.state.orderMode = 'airport';
      const self = this;
      if (index) {
        setTimeout(function () {
          self.navigate('next', index);
        }, 1000);
      }

      this.state.airportDestination = true;
      controls.requestedDate.setValue(moment().add('1', 'hour'));
      // controls.requestedDate.setValue(new Date());
      controls.flightNumber.setValue('KL0896');
      if (returnTrip) {
        // controls.returnRequestedDate.setValue(new Date());
        controls.returnFlightNumber.setValue('AS1259');
      }
      // controls.luggage.setValue(0);
      controls.departureModel.setValue({
        gps: {
          lat: 52.7663081,
          lng: 5.099421000000007
        },
        internationalAlias: 'Overleek 4, 1671 GD Medemblik, Nederland',
        houseNumber: '4',
        streetName: 'Overleek',
        city: 'Medemblik',
        countryCode: 'NL',
        postalCode: '1671GD'
      });
      controls.departure.setValue('Overleek 4, 1671 GD Medemblik, Nederland');
      controls.destinationModel.setValue({
        type: 'airport',
        code: 'AMS',
        gps: {
          lat: '52.30907',
          lng: '4.763385'
        },
        internationalAlias: 'Schiphol (AMS)'
      });
      controls.destination.setValue('Schiphol (AMS)');
      controls.product.setValue({
        isAllowedOnMeter: 'true',
        vehicleType: 'saloon',
        descriptionTag: 'saloon',
        maxPassengers: 4,
        name: 'Super Taxi',
        price: {
          total: 10050,
          currency: 'EUR',
          breakdown: {
            route: {
              total: 10050,
              taxPercentage: 0
            },
            toll: {
              total: 0,
              taxPercentage: 21
            },
            parking: {
              total: 0,
              taxPercentage: 21
            },
            waiting: {
              total: 0,
              taxPercentage: 21
            },
            cleaning: {
              total: 0,
              taxPercentage: 21
            },
            discount: {
              total: 0,
              taxPercentage: 0
            }
          }
        },
        priceReturn: {
          total: 20100,
          currency: 'EUR',
          breakdown: {
            route: {
              total: 10050,
              taxPercentage: 0
            },
            toll: {
              total: 0,
              taxPercentage: 21
            },
            parking: {
              total: 0,
              taxPercentage: 21
            },
            waiting: {
              total: 0,
              taxPercentage: 21
            },
            cleaning: {
              total: 0,
              taxPercentage: 21
            },
            discount: {
              total: 0,
              taxPercentage: 0
            }
          }
        },
        isFixed: 'true'
      });
      controls.returnTrip.setValue(returnTrip);
      if (controls.luggage) {
        controls.luggage.setValue(1);
      }
      controls.firstName.setValue('Martin');
      controls.lastName.setValue('Zwaneveld');
      controls.email.setValue('martin@taxiid.nl');
      controls.phoneNumber.setValue('+31646096022');
      controls.note.setValue('Dit is een test rit!');
      // controls.acceptTermsAndConditions.setValue(true);
      this.selectedFormIndex = index;
    }
  }

  guardNavigationStyle(changes) {
    if (changes['navigation']) {
      let val = (this.navigation ?? '').toString().trim().toLowerCase();
      if(val === 'popup') {
        val = 'modal';
      }
      // Reference the static on OrderComponent itself (where KNOWN_NAV is declared).
      // Going through the InlineWebbookerComponent subclass created an order <-> widget
      // import cycle that TDZ-crashed every order.component unit test under Karma.
      this.navigation = OrderComponent.KNOWN_NAV.has(val) ? val : 'inline';
    }
  }

  onChanges(values): void {
    this._onChanges(values);
  }

  _onChanges(changes): void {
    this.guardNavigationStyle(changes);
    // console.log(this.formGroup.controls['requestedDateMode'].value);
    const hash = md5(JSON.stringify(this.formGroup.value)).toString();
    const values = this.formGroup.value;

    const previousData = this.currentForm;
    if (this.currentFormHash !== hash) {
      this.currentFormHash = hash;
      this.currentForm = values;
      let airportDeparture = (values.departureModel && values.departureModel.type === 'airport') || false;
      let airportDestination = (values.destinationModel && values.destinationModel.type === 'airport') || false;
      this.state.airportDeparture = airportDeparture;
      this.state.airportDestination = airportDestination;


      if(values['product']) {
        this.vatPercentage = values['product']?.price?.taxPercentage || 0;
      }
      if (previousData) {
        if (previousData['departureModel'] !== values['departureModel'] ||
          previousData['destinationModel'] !== values['destinationModel'] ||
          previousData['stopOversModel'] !== values['stopOversModel']) {
          if (this.routePreviewMaps && this.routePreviewMaps.length > 0) {
            this.routePreviewMaps.forEach((routePreviewMap) => {
              routePreviewMap.recalculateRoute();
            });
          }
        }
        // if (this.state.forcedRequestedDateMode) {
        //   this.setCorrectDateField(this.state.forcedRequestedDateMode, 'returnRequestedDate');
        // } else {
          if (previousData && (previousData['requestedDateMode'] !== values['requestedDateMode'] || previousData['returnRequestedDateMode'] !== values['returnRequestedDateMode'])) {
            this.setCorrectDateField(values['requestedDateMode'], values['returnRequestedDateMode']);

            this.formGroup.controls['requestedDateMode'].setValue(values['requestedDateMode']);
            this.formGroup.controls['returnRequestedDateMode'].setValue(values['returnRequestedDateMode']);
          } else {
            this.state.orderMode = (airportDeparture || airportDestination) ? 'airport' : 'default';
            const newMode = this.getDateMode();
            const newReturnMode = this.getDateMode(true);
            const currentMode = this.formGroup.controls['requestedDateMode'].value;
            const currentReturnMode = this.formGroup.controls['returnRequestedDateMode'].value;

            if (newMode !== currentMode || newReturnMode !== currentReturnMode) {
              const patch: any = { requestedDateMode: newMode, returnRequestedDateMode: newReturnMode };
              // Copy the existing date value into the new mode's control so the user
              // doesn't lose their selected date when the airport flips the mode.
              if (newMode !== currentMode && this.formGroup.controls[currentMode]?.value) {
                patch[newMode] = this.formGroup.controls[currentMode].value;
              }
              if (newReturnMode !== currentReturnMode && this.formGroup.controls[currentReturnMode]?.value) {
                patch[newReturnMode] = this.formGroup.controls[currentReturnMode].value;
              }
              this.formGroup.patchValue(patch);
              this.setCorrectDateField(newMode, newReturnMode);
            }
          }
        // }

        if (this.formGroup.controls['phoneNumber'].valid) {
          if (this.formGroup.controls['phoneNumberCountry'].value === 'us') {
            this.toggleSMSAuthorizationRequirement(true);
          } else {
            this.toggleSMSAuthorizationRequirement(false);
          }
        }
      } else if (airportDeparture || airportDestination) {
        // Initial load (previousData is null) with an airport address already saved —
        // apply the same mode-switch logic that normally runs in the else branch above.
        this.state.orderMode = 'airport';
        const newMode = this.getDateMode();
        const newReturnMode = this.getDateMode(true);
        const currentMode = this.formGroup.controls['requestedDateMode'].value;
        const currentReturnMode = this.formGroup.controls['returnRequestedDateMode'].value;
        if (newMode !== currentMode || newReturnMode !== currentReturnMode) {
          const patch: any = { requestedDateMode: newMode, returnRequestedDateMode: newReturnMode };
          if (newMode !== currentMode && this.formGroup.controls[currentMode]?.value) {
            patch[newMode] = this.formGroup.controls[currentMode].value;
          }
          if (newReturnMode !== currentReturnMode && this.formGroup.controls[currentReturnMode]?.value) {
            patch[newReturnMode] = this.formGroup.controls[currentReturnMode].value;
          }
          this.formGroup.patchValue(patch);
          this.setCorrectDateField(newMode, newReturnMode);
        }
      }

      if (!Object.keys(changes).includes('flightnumber') && !Object.keys(changes).includes('phoneNumber') && !Object.keys(changes).includes('firstName') && !Object.keys(changes).includes('lastName') && !Object.keys(changes).includes('email') && !Object.keys(changes).includes('note')) {
        this.calculatePricing(values);
      }
      this.buildMeta(values);
      // this.buildQuotation(values);
      // this.buildOrder(values);

      if (this.selectedFormIndex === (this.form.config.parts.length - 1)) {
        this.checkPageValidity(values, this.selectedFormIndex);
      }

      if (((!previousData || !previousData.product) && values.product) ||
        (previousData && previousData.product && values.product && previousData.product.price.total !== values.product.price.total)) {
        this.getPaymentGateways();
      }
    }
    this.saveState();
  }

  checkPageValidity(values?: any, index?: number) {
    if (!index) {
      index = this.selectedFormIndex;
    }
    if (!this.form.config.parts[index].requirements) {
      this.pageStates[index] = true;
    } else {
      if (!values) {
        values = this.formGroup.getRawValue();
      }
      let valid = true;
      let errorText = 'field_required_error';
      const newErrors: FieldError[] = [];
      const oldErrors: string[] = [];

      if (this.formConfig === 'widget' && index === 0) {
        this.form.config.widgetParts[index].requirements = this.form.config.parts[index].requirements.filter((item, i) => {
          return (i < 2);
        });
      }
      (this.formConfig === 'widget' && this.form.config.widgetParts[index] &&
      this.form.config.widgetParts[index].requirements ? this.form.config.widgetParts[index].requirements : this.form.config.parts[index].requirements).forEach(field => {
        if (field.type === 'collapse' || (this.activeTab === 'hourly' && field.property === 'destination')) {
          return;
        }
        // console.log(`Property '${field.property}' is required and has value '${values[field.property]}`);
        const errorId = `${field.property}Required`;
        let fieldValid = true;
        errorText = 'field_required_error';

        if (field.showIf && field.showIf.addressAirport === 'any' && this.state.orderMode !== 'airport') {
          fieldValid = true;
        } else {
          if (typeof values[field.property] === 'undefined') {
            // console.log(`field '${field.property}' undefined, valid is false!`);
            valid = false;
            fieldValid = false;
          }
          if (values[field.property] === '') {
            // console.log(`field '${field.property}' empty, valid is false!`);
            valid = false;
            fieldValid = false;
          }
          if (field.type === 'checkbox' && values[field.property] !== true) {
            // console.log(`field '${field.property}' false, valid is false!`);
            valid = false;
            fieldValid = false;
          }
          if (field.type === 'dateTime' && values[field.property] === '' && field.property !== values['requestedDateMode']) {
            // console.log(`field '${field.property}' false, valid is false!`);
            valid = true;
            fieldValid = true;
          }
          if (field.type === 'email' && values[field.property]) {
            const re = new RegExp(/^[\w]{1,}[\w.+-]{0,}@[\w-]{1,}([.][a-zA-Z]{2,}|[.][\w-]{2,}[.][a-zA-Z]{2,})$/);
            const isValidEmail = re.test(values[field.property]);
            if (!isValidEmail) {
              valid = false;
              fieldValid = false;
              errorText = 'field_invalid_email_error';
            }
          }

          if (field.type === "address" && field.property === "departure") {
            if (values.departure && values.departureModel && values.destinationModel && values.departureModel.gps.lat === values.destinationModel.gps.lat && this.activeTab !== 'hourly') {
              valid = false;
              fieldValid = false;
              errorText = 'field_duplicate_address_error';
            }
          }

          // console.log(`field '${field.property}' is valid: ${fieldValid}`);
          if (!fieldValid) {
            newErrors.push({
              id: errorId,
              property: field.property,
              text: errorText,
              label: field.label,
            });
          } else {
            oldErrors.push(errorId);
          }
        }
      });

      this.form.config.parts[index].fields.forEach(field => {
        if (field.type === 'collapse') {
          return;
        }
        let fieldValid = true;
        const errorId = `${field.property}Valid`;

        if (field.type === "address" && field.property === "departure") {
          if (values.departure && (!values.departureModel || !values.departureModel.gps || !values.departureModel.gps.lat)) {
            valid = false;
            fieldValid = false;
            errorText = 'field_invalid_selection';
          }
        }
        if (field.type === "address" && field.property === "destination") {
          if (values.destination && (!values.destinationModel || !values.destinationModel.gps || !values.destinationModel.gps.lat) && this.activeTab !== 'hourly') {
            valid = false;
            fieldValid = false;
            errorText = 'field_invalid_selection';
          }
        }

        if (field.type === "flightNumber" && field.property === "flightNumber") {
          if (field.requiredAirportPickup && values[field.property] === '' && values.departureModel && values.departureModel.type === 'airport' && this.activeTab !== 'hourly') {
            valid = false;
            fieldValid = false;
          }
          if (field.requiredAirportDestination && values[field.property] === '' && values.destinationModel && values.destinationModel.type === 'airport' && this.activeTab !== 'hourly') {
            valid = false;
            fieldValid = false;
          }
        } else if (field.type === "flightNumber" && field.property === "returnFlightNumber" && values.returnTrip) {
          if (field.requiredAirportPickup && values[field.property] === '' && values.destinationModel && values.destinationModel.type === 'airport' && this.activeTab !== 'hourly') {
            valid = false;
            fieldValid = false;
          }
          if (field.requiredAirportDestination && values[field.property] === '' && values.departureModel === 'airport' && this.activeTab !== 'hourly' && values.departureModel.type === 'airport') {
            valid = false;
            fieldValid = false;
          }
        }

        if (!fieldValid) {
          newErrors.push({
            id: errorId,
            property: field.property,
            text: errorText,
            label: field.label,
          });
        } else {
          oldErrors.push(errorId);
        }
      });

      this.errorService.addErrors(newErrors);
      this.errorService.removeErrors(oldErrors);
      if (this.form.config.forceAirport) {
        this.checkForcedAirport();
      }
      if (this.form.config.forceFlightNumbers) {
        this.checkForcedFlightNumbers();
      }
      // this.checkOtherErrors();
      // console.log(index);
      // console.log(valid);
      // console.log(this.isErroneous);

      if (this.serviceAreaError) {
        valid = false;
      }
      this.form.config.parts[index].fields.forEach(field => {
        if (this.errorService.fieldHasErrors(field.property)) {
          valid = false;
        }
      });
      this.pageStates[index] = valid && !this.isErroneous;
    }
  }

  checkOtherErrors(): void {
    this.form.config.parts[this.selectedFormIndex].fields.forEach(field => {
      if (this.errorService.fieldHasErrors(field.property)) {
        this.isErroneous = true;
      }
    });
  }

  checkForcedAirport(): void {
    const departure = this.formGroup.controls.departureModel.value;
    const destination = this.formGroup.controls.destinationModel.value;
    const errorId = `airportAddressRequired`;
    const departureErrorId = `departureAirportAddressRequired`;
    const destinationErrorId = `destinationAirportAddressRequired`;

    if ((!departure || departure.type !== 'airport') && (!destination || destination.type !== 'airport')) {
      this.errorService.addErrors([
        {
          id: errorId,
          property: 'global',
          text: 'airport_required_error',
          label: '',
        },
        {
          id: departureErrorId,
          property: 'departure',
        },
        {
          id: destinationErrorId,
          property: 'destination',
        },
      ]);
    } else {
      this.errorService.removeErrors([errorId, departureErrorId, destinationErrorId]);
    }
  }

  checkForcedFlightNumbers(): void {
    const flightNumber = this.formGroup.controls.flightNumber.value;
    const returnFlightNumber = this.formGroup.controls.returnFlightNumber.value;
    const flightNumberErrorId = 'flightNumberRequired';
    const returnFlightNumberErrorId = 'returnFlightNumberRequired';
    if (!flightNumber && this.state.orderMode === 'airport') {
      // console.log(this.order.jobs[0].departure.type);
      // console.log(this.order.jobs[0].destination.type);
      this.errorService.addErrors([
        {
          id: flightNumberErrorId,
          property: 'flightNumber',
          text: 'field_required_error',
          label: '',
        },
      ]);
    } else {
      this.errorService.removeError(flightNumberErrorId);
    }

    if (!returnFlightNumber && this.state.orderMode === 'airport' && this.formGroup.controls.returnTrip.value) {
      this.errorService.addErrors([
        {
          id: returnFlightNumberErrorId,
          property: 'returnFlightNumber',
          text: 'field_required_error',
          label: '',
        },
      ]);
    } else {
      this.errorService.removeError(returnFlightNumberErrorId);
    }
  }

  /**
   * Resolve the surcharge for a gateway. Two config shapes are supported:
   *  - portal setup: `gateway.transactionCost = {fixed, percentage}` (fixed in currency units)
   *  - legacy: `config.payment.transactionCosts[gatewayId] = [{type, amount}]` (fixed in cents)
   * Returns the normalized list (fixed in cents), or undefined when there is no surcharge.
   */
  private resolveTransactionCosts(gateway: any, legacy: any): TransactionCosts[] | undefined {
    const cost = gateway?.transactionCost;
    if (cost && (Number(cost.fixed) > 0 || Number(cost.percentage) > 0)) {
      const costs: TransactionCosts[] = [];
      if (Number(cost.percentage) > 0) {
        costs.push({ type: TransactionCostType.Percentage, amount: Number(cost.percentage) });
      }
      if (Number(cost.fixed) > 0) {
        costs.push({ type: TransactionCostType.Fixed, amount: Math.round(Number(cost.fixed) * 100) });
      }
      return costs;
    }
    return legacy?.[gateway?.id];
  }

  getPaymentGateways(): void {
    let gateways = this.form.config.payment.gateways;
    const transactionCosts = this.form.config.payment.transactionCosts;

    const hasMultiSafepay = gateways.some(g => g.id === 'MULTISAFEPAY');
    const hasStripe = gateways.some(g => g.id === 'STRIPE');
    const msp = gateways.filter(g => g.id === 'MULTISAFEPAY');

    const processGateways = (backendGateways: any[] = []) => {
      if (hasMultiSafepay) {
        if(msp.individual) {
          gateways = gateways.filter(g => g.id !== 'MULTISAFEPAY');
        }
      }

      if (backendGateways.length) {
        gateways = this.form.config.pspFirst
          ? backendGateways.concat(gateways)
          : gateways.concat(backendGateways);
      }

      const gatewayData: PaymentGateway[] = [];

      gateways.forEach((gateway, i) => {
        const costs = this.resolveTransactionCosts(gateway, transactionCosts);
        if (costs) {
          gateways[i].transactionCosts = costs;
        }
        gatewayData[gateway.id] = gateways[i];
      });

      const hasPrice =
        this.formGroup.controls['product']?.value?.price?.total > 0;

      gateways = gateways.filter(gateway =>
        hasPrice
          ? !gateway.onlyMetered
          : gateway.directProcess && !gateway.psp && !gateway.provider
      );

      this.state.paymentGateways = gateways;
      this.paymentGateways = gatewayData;

      if (gateways[0]) {
        this.formGroup.controls.paymentMethod.setValue(gateways[0].id);
      }

      if (this.passenger?.passengerId) {
        const methods = [];

        this._customerService.getPaymentMethods().subscribe((paymentMethods: any[]) => {
          paymentMethods.forEach((method: any) => {
            methods.push({
              id: `ONACCOUNT_${method.debtorId}`,
              description: `${this.translate.instant('payment_method_on_account')} ${method.name}`,
              directProcess: true,
              transactionCosts: 0
            });
          });

          gateways.forEach(method => methods.push(method));

          gateways = methods.filter(gateway =>
            gateway.directProcess ||
            this.formGroup.controls['product']?.value?.price?.total > 0
          );

          if (gateways[0]) {
            this.formGroup.controls.paymentMethod.setValue(gateways[0].id);
          }

          this.state.paymentGateways = gateways;

          const updatedGatewayData: PaymentGateway[] = [];
          gateways.forEach((gateway, i) => {
            const costs = this.resolveTransactionCosts(gateway, transactionCosts);
            if (costs) {
              gateways[i].transactionCosts = costs;
            }
            updatedGatewayData[gateway.id] = gateways[i];
          });

          this.paymentGateways = updatedGatewayData;
        });
      }
    };

    if (!hasMultiSafepay || !msp.individual) {
      processGateways();
      return;
    }
    if(msp.individual) {
      this.apiService
        .getCustom('/payments/multisafepay/gateways')
        .subscribe(result => {
          processGateways(result?.data || []);
        });
    }
  }

  /**
   * Evaluates a field's `showIf` condition the same way FieldWrapperComponent does,
   * so pricing/summary logic never counts a conditionally-hidden field. Without this,
   * a hidden field (e.g. a departure-airport-only select left on its default option)
   * still leaks into the summary product/surcharge lines. Returns true when the field
   * has no condition or the condition is currently met.
   *
   * `leg` only affects the `addressAirport` check, which is otherwise ambiguous on a
   * round trip because 'departure'/'destination' swap between the outbound and return
   * job. Omit it (existing callers, all of them gating a combined "is this visible at
   * all" decision before their own leg-splitting logic runs) to get the pre-existing
   * either-leg-matches behaviour. Pass 'single' or 'return' when the caller is about to
   * write leg-specific data (see buildMeta) so a field gated to only one leg doesn't
   * leak into the other leg's data.
   */
  isConditionalFieldActive(field: any, values: any, leg?: 'single' | 'return'): boolean {
    const showIf = field?.showIf;
    if (!showIf) {
      return true;
    }
    return Object.keys(showIf).every((key) => {
      const expected = showIf[key];
      if (key === 'addressAirport') {
        if (expected === 'any') {
          return this.state.airportDeparture || this.state.airportDestination;
        }
        if (!leg) {
          if (expected === 'departure') {
            return this.state.airportDeparture || (values?.returnTrip && this.state.airportDestination);
          }
          if (expected === 'destination') {
            return this.state.airportDestination || (values?.returnTrip && this.state.airportDeparture);
          }
          return false;
        }
        // Leg-aware: on the return job, departure/destination are the outbound's
        // destination/departure respectively, and only apply when a return is booked.
        if (leg === 'single') {
          if (expected === 'departure') {
            return this.state.airportDeparture;
          }
          if (expected === 'destination') {
            return this.state.airportDestination;
          }
        } else {
          if (expected === 'departure') {
            return !!values?.returnTrip && this.state.airportDestination;
          }
          if (expected === 'destination') {
            return !!values?.returnTrip && this.state.airportDeparture;
          }
        }
        return false;
      }
      if (key === 'orderMode') {
        // Mirror FieldWrapperComponent: only enforce orderMode once it is known.
        return !this.state.orderMode || this.state.orderMode === expected;
      }
      if (key === 'product' && Array.isArray(expected)) {
        const selectedProductId = values?.product?.productId;
        return !!selectedProductId && expected.includes(selectedProductId);
      }
      if (key === 'productSku' && expected) {
        // A single sku may be configured as a plain string; normalise so both shapes work.
        // Matched case-insensitively: skus are hand-typed in the portal config, while the
        // product's own sku is upper-case (see the .toLowerCase() calls in loadProducts()).
        const expectedSkus = (Array.isArray(expected) ? expected : [expected]).map((sku) => String(sku).toLowerCase());
        const selectedSku = values?.product?.sku;
        return !!selectedSku && expectedSkus.includes(String(selectedSku).toLowerCase());
      }
      // Generic condition: any other key is the `property` of another field on the same
      // part (or a top-level order value, e.g. `returnTrip`) — pass when that field's
      // current value strictly equals the configured value, e.g. `{ businessRide: true }`.
      // Mirrors FieldWrapperComponent.setFieldState's own generic `values[key]` fallback.
      return values?.[key] === expected;
    });
  }

  /**
   * v2-authored surcharge fields (api.taxiid.nl CompanyFieldWebbookerSyncService) carry
   * returnSurchargeMode/payoutToDriver on field.product. These keys never existed on the
   * legacy stack, so their presence uniquely marks the new per-leg contract.
   */
  isPerLegMutation(mutation: any): boolean {
    return !!mutation && (mutation.returnSurchargeMode !== undefined || mutation.payoutToDriver !== undefined);
  }

  /**
   * True when the field's `product` mutation yields a finite charge for the current value,
   * i.e. the productMutations loop in calculatePricing() already bills this field. Mirrors
   * that loop's arithmetic (amount x selected value, so a non-numeric option value is NaN
   * and falls through to the per-option costs).
   */
  private isChargedByProductMutation(fieldConfig: any, values: any): boolean {
    const mutation = fieldConfig.product;
    if (!mutation || !(this.isPerLegMutation(mutation) || mutation.amount)) {
      return false;
    }
    const selected = values[fieldConfig.property];
    return !!selected && Number.isFinite(mutation.amount * selected);
  }

  private buildSurchargeProduct(field: any, legAmount: number): Product {
    if (!field.label) {
      field.label = this.translate.instant(`label_${field.id}`);
    }
    const product: Product = {
      label: field.label,
      sku: field.property,
      description: this.translate.instant(field.label),
      amount: {
        total: legAmount,
        currency: this.state.currency,
        taxPercentage: field.mutation.taxPercentage,
      }
    };
    // Carry the settlement metadata through onto the submitted line so api.taxiid.nl can
    // split commission/driver payout downstream. The passenger always pays the full
    // surcharge regardless of payoutToDriver, so this never changes the passenger total.
    if (field.mutation.payoutToDriver !== undefined) {
      product.payoutToDriver = field.mutation.payoutToDriver;
    }
    if (field.mutation.returnSurchargeMode !== undefined) {
      product.returnSurchargeMode = field.mutation.returnSurchargeMode;
    }
    return product;
  }

  /**
   * Apply a v2 per-leg surcharge. amount charges the outbound/single leg and returnAmount
   * charges the return leg — both final (no /2). Mirrors the select/calculatedCosts path:
   * a distinct line item per leg, never folded into the fare. Zero-value legs (e.g. the
   * return leg of an 'outbound' returnSurchargeMode) are skipped so no €0 rows appear.
   */
  private applyPerLegMutation(field: any, fieldConfig: any, values: any): void {
    const outboundAmount = field.mutation.amount;
    const returnAmount = field.mutation.returnAmount || 0;

    const outboundProduct = this.buildSurchargeProduct(field, outboundAmount);
    // Clone for the display slot so it never aliases the line item pushed into
    // singleProducts (defensive against future in-place mutation of either).
    this.displayProducts[field.property] = JSON.parse(JSON.stringify(outboundProduct));

    if (!values[field.property] || !this.isConditionalFieldActive(fieldConfig, values)) {
      return;
    }

    const type = field.mutation.type;

    if (type === 'airportDepartureJob' || type === 'airportDestinationJob') {
      // Airport-job surcharges land on the single leg that touches the airport. On a
      // return trip that is the return leg unless the outbound leg departs the airport.
      const onReturnLeg = values.returnTrip && !this.state.airportDeparture;
      const legAmount = onReturnLeg ? returnAmount : outboundAmount;
      if (!Number.isFinite(legAmount) || legAmount === 0) {
        return;
      }
      if (onReturnLeg) {
        this.returnProducts.push(this.buildSurchargeProduct(field, returnAmount));
        this.returnPrice += returnAmount;
      } else {
        this.singleProducts.push(outboundProduct);
        this.singlePrice += outboundAmount;
      }
      return;
    }

    // 'global' (also legacy-style 'single'/'return' should one appear on a v2 field):
    // charge the outbound leg its amount and, on a return trip, the return leg its
    // returnAmount, as separate line items.
    if (type !== 'return' && Number.isFinite(outboundAmount) && outboundAmount !== 0) {
      this.singleProducts.push(outboundProduct);
      this.singlePrice += outboundAmount;
    }
    if (values.returnTrip && type !== 'single' && Number.isFinite(returnAmount) && returnAmount !== 0) {
      this.returnProducts.push(this.buildSurchargeProduct(field, returnAmount));
      this.returnPrice += returnAmount;
    }
  }

  calculatePricing(values?: any): void {
    if (!values) {
      values = this.formGroup.getRawValue();
    }
    this.totalPrice = 0;
    this.singlePrice = 0;
    this.returnPrice = 0;
    this.transactionCosts = 0;
    this.singleProducts = [];
    this.returnProducts = [];
    this.jobPrice = DefaultPrice;
    this.jobPriceReturn = DefaultPrice;
    this.displayProducts = {};

    if (!values.product) {
      return;
    }

    this.selectedProducts = [
      JSON.parse(JSON.stringify(values.product)),
      JSON.parse(JSON.stringify(values.product))
    ]

    const selectedProduct = JSON.parse(JSON.stringify(values.product));
    const selectedProductReturn = JSON.parse(JSON.stringify(values.product));

    // console.log('[selectedProduct]', selectedProduct);
    // console.log('[selectedProductReturn]', selectedProductReturn);

    const isMeteredProduct = !selectedProduct?.price?.total;

    if (selectedProduct) {
      // console.log('Calculating single prices', selectedProduct.price);
      this.singlePrice = JSON.parse(JSON.stringify(selectedProduct.price.total));
    }
    if (values.returnTrip) {
      // console.log('Calculating single prices', selectedProductReturn.priceReturn);
      this.returnPrice = JSON.parse(JSON.stringify(selectedProductReturn.priceReturn.total));
    }

    if(this.productMutations) {
      this.productMutations.forEach((fieldConfig) => {
        let field = JSON.parse(JSON.stringify(fieldConfig));
        if (['number', 'select'].includes(field.type) && field.mutation && field.mutation.amount) {
          field.mutation.amount = field.mutation.amount * values[field.property];
          if (field.mutation.returnAmount) {
            field.mutation.returnAmount = field.mutation.returnAmount * values[field.property];
          }
        }

        // v2-authored fields (api.taxiid.nl) carry the new per-leg contract: amount is
        // the final outbound-leg charge and returnAmount the final return-leg charge,
        // already split (both/split/outbound) by the backend. Apply them per leg with
        // no halving. Legacy fields lack these keys and keep the total-then-halve path.
        if (this.isPerLegMutation(field.mutation)) {
          this.applyPerLegMutation(field, fieldConfig, values);
          return;
        }

        let calculatedAmount = values.returnTrip ?
          (field.mutation.returnAmount ? (field.mutation.returnAmount / 2) : field.mutation.amount) :
          field.mutation.amount;

        if(!field.label) {
          field.label = this.translate.instant(`label_${field.id}`);
        }
        const product: Product = {
          label: field.label,
          sku: field.property,
          description: this.translate.instant(field.label),
          amount: {
            total: calculatedAmount,
            currency: this.state.currency,
            taxPercentage: field.mutation.taxPercentage,
          }
        };

        this.displayProducts[field.property] = product;

        if (values[field.property] &&
            this.isConditionalFieldActive(fieldConfig, values) &&
            Number.isFinite(calculatedAmount)) {
          if (field.mutation.type === 'global') {
            if (values.returnTrip) {
              product.summaryTotal = calculatedAmount * 2;
            }
            this.singleProducts.push(product);
            this.returnProducts.push(product);
            if (values.returnTrip) {
              this.singlePrice += calculatedAmount;
              this.returnPrice += calculatedAmount;
            } else {
              this.singlePrice += calculatedAmount;
            }
          } else if (field.mutation.type === 'single') {
            this.singleProducts.push(product);
            this.singlePrice += calculatedAmount;
          } else if (field.mutation.type === 'return') {
            this.returnProducts.push(product);
            this.returnPrice += calculatedAmount;
          } else if (field.mutation.type === 'airportDestinationJob') {
            if (values.returnTrip) {
              if (this.state.airportDeparture) {
                this.singleProducts.push(product);
                this.singlePrice += calculatedAmount;
              } else {
                this.returnProducts.push(product);
                this.returnPrice += calculatedAmount;
              }
            } else {
              this.singleProducts.push(product);
              this.singlePrice += calculatedAmount;
            }
          } else if (field.mutation.type === 'airportDepartureJob') {
            if (values.returnTrip) {
              if (this.state.airportDeparture) {
                // First job departs from airport → surcharge on first job
                this.singleProducts.push(product);
                this.singlePrice += calculatedAmount;
              } else {
                // Return job departs from airport (airportDestination booking) → surcharge on return job
                this.returnProducts.push(product);
                this.returnPrice += calculatedAmount;
              }
            } else {
              this.singleProducts.push(product);
              this.singlePrice += calculatedAmount;
            }
          }
        }
      });
    }

    /**
     * Select fields with per-option surcharges (values[].calculatedCosts) — these are
     * known from the form setup and shown in the option label on step 1. They are
     * applied here as a surcharge line item, not as part of the route quotation.
     * Metered products have no fixed price to surcharge, so they are skipped.
     */
    this.optionSurchargeFields.forEach((fieldConfig) => {
      if (isMeteredProduct) {
        return;
      }
      if (!this.isConditionalFieldActive(fieldConfig, values)) {
        return;
      }
      // api.taxiid.nl writes the same surcharge twice on a numeric select: as `field.product`
      // (applied by the productMutations loop above) AND as per-option calculatedCosts[Return].
      // When the product mutation already charges for this value, applying the option cost too
      // bills every leg twice (a return trip came to 4x instead of 2x).
      if (this.isChargedByProductMutation(fieldConfig, values)) {
        return;
      }
      const selectedOption = (fieldConfig.values || []).find((v: any) => v.value === values[fieldConfig.property]);
      if (!selectedOption) {
        return;
      }
      let label = fieldConfig.label;
      if (!label) {
        label = this.translate.instant(`label_${fieldConfig.id}`);
      }
      if (selectedOption.calculatedCosts) {
        const product: Product = {
          label,
          sku: fieldConfig.property,
          description: this.translate.instant(label),
          amount: {
            total: selectedOption.calculatedCosts,
            currency: this.state.currency,
            taxPercentage: selectedProduct.price?.breakdown?.route?.taxPercentage ?? 0,
          }
        };
        this.displayProducts[fieldConfig.property] = product;
        this.singleProducts.push(product);
        this.singlePrice += selectedOption.calculatedCosts;
      }
      if (values.returnTrip && selectedOption.calculatedCostsReturn) {
        const productReturn: Product = {
          label,
          sku: fieldConfig.property,
          description: this.translate.instant(label),
          amount: {
            total: selectedOption.calculatedCostsReturn,
            currency: this.state.currency,
            taxPercentage: selectedProduct.price?.breakdown?.route?.taxPercentage ?? 0,
          }
        };
        this.returnProducts.push(productReturn);
        this.returnPrice += selectedOption.calculatedCostsReturn;
      }
    });

    this.state.paymentGateways.forEach((method) => {
      if (method.id === values.paymentMethod) {
        // Price the selected method's fee from the CURRENT fare here, instead of relying on
        // calculatedCosts having been filled in earlier: the default method (e.g. cash to
        // driver +€2.00) is selected before anything called getPaymentMethodCosts(), so its
        // fee stayed 0 until the customer switched method and back. Mutates the gateway in
        // place so the "(+€x)" label in the method list stays in sync.
        if (method.transactionCosts) {
          const fare = selectedProduct.price.total +
            (values.returnTrip ? (selectedProductReturn.priceReturn?.total ?? 0) : 0);
          method.calculatedCosts = this.calculateTransactionCosts(fare, method.transactionCosts);
        }
        this.transactionCosts = method.calculatedCosts;
      }
    });

    if (this.transactionCosts) {
      if (this.state.couponDiscount) {
        this.calculateCouponDiscount(selectedProduct, selectedProductReturn);
        let tmpSelectedProduct = JSON.parse(JSON.stringify(selectedProduct));
        let tmpSelectedProductReturn = null;

        tmpSelectedProduct.price.total = tmpSelectedProduct.price.total + this.state.couponDiscount.discount;
        if (tmpSelectedProduct.price.breakdown) {
          tmpSelectedProduct.price.breakdown.route.total = tmpSelectedProduct.price.total;
        }
        if (values.returnTrip) {
          tmpSelectedProductReturn = JSON.parse(JSON.stringify(selectedProductReturn));
          tmpSelectedProductReturn.priceReturn.total = tmpSelectedProduct.price.total + this.state.couponDiscount.discountRetour;
          if (tmpSelectedProductReturn && tmpSelectedProductReturn.priceReturn.breakdown) {
            tmpSelectedProductReturn.priceReturn.breakdown.route.total = tmpSelectedProductReturn.priceReturn.total;
          }
        }
        this.getPaymentMethodCosts(tmpSelectedProduct, tmpSelectedProductReturn);
        this.state.paymentGateways.forEach((method) => {
          if (method.id === values.paymentMethod) {
            this.transactionCosts = method.calculatedCosts;
          }
        });
      }

      if (values.returnTrip) {
        this.singlePrice = this.singlePrice + Math.ceil(this.transactionCosts / 2);
        this.returnPrice = this.returnPrice + Math.floor(this.transactionCosts / 2);
      } else {
        this.singlePrice = this.singlePrice + this.transactionCosts;
      }
    }

    this.calculateCouponDiscount(selectedProduct, selectedProductReturn);

    if (this.state.couponDiscount) {
      this.singlePrice = this.singlePrice + this.state.couponDiscount.discount;

      if (selectedProductReturn && values.returnTrip) {
        this.returnPrice = this.returnPrice + this.state.couponDiscount.discountRetour;
      }
    }

    if (isMeteredProduct) {
      this.singlePrice = 0;
      this.returnPrice = 0;
    }

    this.totalPrice = Math.round(this.singlePrice + this.returnPrice);

    const singleBreakdown = selectedProduct.price.breakdown || {};
    this.jobPrice = {
      total: this.singlePrice,
      currency: selectedProduct.price.currency,
      breakdown: {
        route: {
          total: this.singlePrice,
          taxPercentage: singleBreakdown.route?.taxPercentage ?? 0
        },
        toll: {
          total: 0,
          taxPercentage: singleBreakdown.toll?.taxPercentage ?? 0
        },
        parking: {
          total: 0,
          taxPercentage: singleBreakdown.parking?.taxPercentage ?? 0
        },
        waiting: {
          total: 0,
          taxPercentage: singleBreakdown.waiting?.taxPercentage ?? 0
        },
        cleaning: {
          total: 0,
          taxPercentage: singleBreakdown.cleaning?.taxPercentage ?? 0
        },
        discount: {
          total: 0,
          taxPercentage: singleBreakdown.discount?.taxPercentage ?? 0
        }
      }
    }

    if (values.returnTrip) {
      const returnBreakdown = (selectedProductReturn.priceReturn || selectedProductReturn.price || {}).breakdown || singleBreakdown;
      this.jobPriceReturn = {
        total: this.returnPrice,
        currency: selectedProduct.price.currency,
        breakdown: {
          route: {
            total: this.returnPrice,
            taxPercentage: returnBreakdown.route?.taxPercentage ?? 0
          },
          toll: {
            total: 0,
            taxPercentage: returnBreakdown.toll?.taxPercentage ?? 0
          },
          parking: {
            total: 0,
            taxPercentage: returnBreakdown.parking?.taxPercentage ?? 0
          },
          waiting: {
            total: 0,
            taxPercentage: returnBreakdown.waiting?.taxPercentage ?? 0
          },
          cleaning: {
            total: 0,
            taxPercentage: returnBreakdown.cleaning?.taxPercentage ?? 0
          },
          discount: {
            total: 0,
            taxPercentage: returnBreakdown.discount?.taxPercentage ?? 0
          }
        }
      }
    }

    this.state.pricingData = {
      ...this.state.pricingData,
      single: this.singlePrice,
      return: this.returnPrice,
      transaction: this.transactionCosts,
      total: this.totalPrice,
    };
    // console.log(`this.state.pricingData: ${this.state.pricingData}`);
    // console.log(this.state.pricingData);
    // console.log(`total price: ${this.totalPrice}`);
    // console.log(`single price: ${this.singlePrice}`);
    // console.log(`return price: ${this.returnPrice}`);
    // console.log(`transactionCosts: ${this.transactionCosts}`);
    // console.log(`discountPrice: ${this.discountPrice}`);
    // if (selectedProduct && selectedProduct.price && selectedProduct.price.breakdown && selectedProduct.price.breakdown.discount) {
    //   console.log(`discount: ${(selectedProduct.price.breakdown.discount.total ? selectedProduct.price.breakdown.discount.total : 0)}`);
    // }
    // console.log(`single products`, this.singleProducts);
    // console.log(`single products`, this.returnProducts);
    // console.log('metaFields', this.metaFields);
    // console.log('--------------');
  }

  calculateTransactionCosts(price: number, costs: TransactionCosts[]): number {
    let transactionCosts = 0;
    costs.forEach(cost => {
      if (cost.type === TransactionCostType.Fixed) {
        transactionCosts += cost.amount;
      } else if (cost.type === TransactionCostType.Percentage) {
        transactionCosts += Math.round(((price) / 100) * cost.amount);
      }
    });
    return transactionCosts;
  }

  calculateCouponDiscount(product, productReturn) {
    if (!this.state.couponDiscount)
      return;
    /**
     * Sometimes the discount is already filled because of the special rates. The discount can also be positive in
     * that case it is an price increase from the special rates!
     */
    let discount = 0;
    let discountRetour = 0;

    if (this.state.couponDiscount.discountType === 'fixed') {
      discount = (0 - parseInt(String(this.state.couponDiscount.value)));
      discountRetour = (0 - parseInt(String(this.state.couponDiscount.value)));
    } else if (this.state.couponDiscount.discountType === 'balance') {
      discount = (0 - (this.state.couponDiscount.balanceLimitByCustomer < this.state.couponDiscount.maxDiscount ? this.state.couponDiscount.balanceLimitByCustomer : this.state.couponDiscount.maxDiscount));
      discountRetour = 0;
      if (this.state.couponDiscount.balanceLimitByCustomer > product.price.total) {
        const leftOver = this.state.couponDiscount.balanceLimitByCustomer - product.price.total;
        discountRetour = (0 - (leftOver < this.state.couponDiscount.maxDiscount ? leftOver : this.state.couponDiscount.maxDiscount));
      }
    } else {

      let total = product.price.total;
      const addedProducts = JSON.parse(JSON.stringify(this.singleProducts));
      const addedProductsReturn = JSON.parse(JSON.stringify(this.returnProducts));

      if(addedProducts && addedProducts.length > 0) {
        addedProducts.forEach(p => {
          total += p?.amount?.total;
        });
      }
      discount =
        Math.round(0 - ((total / 100) * parseInt(String(this.state.couponDiscount.value))));
      if (productReturn && productReturn.priceReturn?.total) {
        let totalReturn = productReturn.priceReturn.total;
        addedProductsReturn.forEach(p => {
          totalReturn += p?.amount?.total;
        });
        discountRetour =
          Math.round(0 - ((totalReturn / 100) * parseInt(String(this.state.couponDiscount.value))));
      }
    }

    // Never exceed the coupon's maximum discount (set in the portal as the coupon limit). Percentage and fixed
    // discounts are calculated here, so the cap from the validation response has to be enforced here too.
    const maxDiscount = Number(this.state.couponDiscount.maxDiscount);
    if (this.state.couponDiscount.discountType !== 'balance' && maxDiscount > 0) {
      discount = Math.max(discount, 0 - maxDiscount);
      discountRetour = Math.max(discountRetour, 0 - maxDiscount);
    }

    // The return-leg discount only applies when an actual return trip is booked. Without it,
    // discountRetour is never applied to the price (see the values.returnTrip guards above) but
    // would still inflate the discount shown in the summary, so force it to 0 here.
    if (!this.formGroup.controls.returnTrip.value) {
      discountRetour = 0;
    }

    this.state.couponDiscount.discount = discount;
    this.state.couponDiscount.discountRetour = discountRetour;
  }

  buildQuotation(values: any): void {
    const singleMeta = {};
    const singleForeignMeta = {};
    Object.keys(this.singleMeta).forEach(key => {
      if (this.quotationFields.indexOf(key) > -1) {
        singleMeta[key] = this.singleMeta[key];
      }
    });
    Object.keys(this.singleForeignMeta).forEach(key => {
      if (this.quotationFields.indexOf(key) > -1) {
        singleForeignMeta[key] = this.singleForeignMeta[key];
      }
    });
    this.quotation = {
      passengerCount: (values.passengerCount ? Number(values.passengerCount) : 1),
      departure: values.departureModel,
      duration: (values.duration ? (values.duration * 60 * 60) : 0),
      meta: singleMeta,
      foreignMeta: singleForeignMeta,
    };

    // Always send the luggage amount when the form has a luggage field; the
    // restrictProductsByLuggage flag only matters for the order/job payloads.
    if (this.restrictProductsByLuggage || values.luggage != null) {
      this.quotation.luggageCount = Number(values.luggage) || 0;
    }

    if (values.destinationModel) {
      this.quotation.destination = values.destinationModel;
    }

    this.quotation[values.requestedDateMode] = (values[values.requestedDateMode] ? values[values.requestedDateMode] : values.requestedDate);

    if (this.formGroup.controls.returnTrip.value) {
      if (values[values.returnRequestedDateMode]) {
        this.quotation[values.returnRequestedDateMode] = values[values.returnRequestedDateMode];
      }
      if (!values[values.requestedDateMode] && values.requestedDate) {
        values[values.requestedDateMode] = values.requestedDate;
      }
    }
    if (values.stopOvers) {
      // Drop empty stopover rows (an added-but-unfilled row keeps its seeded []),
      // otherwise the payload contains stopOvers: [[]].
      this.quotation.stopOvers = this.sendableStopOvers(values);
    }

  }

  buildMeta(values: any): void {
    this.metaFields.forEach(field => {
      // Hidden fields (showIf not met) must not leak into the order's meta/foreignMeta —
      // otherwise a conditionally-hidden select's default option still shows up as an
      // order detail even though the field itself was never shown to the customer.
      // Evaluated per leg (not one combined boolean): a round trip can have a field
      // that's shown for the outbound job but not the return job (or vice versa) —
      // e.g. showIf: {addressAirport: 'destination'} only actually applies to whichever
      // leg touches that airport — so each leg's meta is gated independently. Delete
      // rather than skip when inactive: these meta objects persist across calls, so a
      // leg that was active earlier (e.g. airport toggled off again) must be cleared.
      const singleActive = this.isConditionalFieldActive(field, values, 'single');
      const returnActive = this.isConditionalFieldActive(field, values, 'return');

      if (!singleActive) {
        delete this[field.meta ? 'singleMeta' : 'singleForeignMeta'][field.property];
      }
      if (!returnActive) {
        delete this[field.meta ? 'returnMeta' : 'returnForeignMeta'][field.property];
      }
      if (!singleActive && !returnActive) {
        return;
      }

      if (field.metaRule) {
        if (field.metaRule === 'airportDestinationJob' && values.destinationModel) {
          if (values.destinationModel.type === 'airport') {
            // console.log(`RULE FIELD: set on single meta cause airport destination job`);
            if (singleActive) {
              this[field.meta ? 'singleMeta' : 'singleForeignMeta'][field.property] = this.numericFields.indexOf(field.property) > -1 ?
                Number(values[field.property]) :
                values[field.property];
            }
          } else if (values.returnTrip && values.departureModel.type === 'airport') {
            // console.log(`RULE FIELD: set on return meta cause airport destination job`);
            if (returnActive) {
              this[field.meta ? 'returnMeta' : 'returnForeignMeta'][field.property] = this.numericFields.indexOf(field.property) > -1 ?
                Number(values[field.property]) :
                values[field.property];
            }
          }
        }
      } else {
        // console.log(`NO RULE FIELD: set on single and return meta`);
        if (singleActive) {
          this[field.meta ? 'singleMeta' : 'singleForeignMeta'][field.property] = this.numericFields.indexOf(field.property) > -1 ?
            Number(values[field.property]) :
            values[field.property];
        }
        if (returnActive) {
          this[field.meta ? 'returnMeta' : 'returnForeignMeta'][field.property] = this.numericFields.indexOf(field.property) > -1 ?
            Number(values[field.property]) :
            values[field.property];
        }
      }
    });
    this.singleForeignMeta.productSku = values.product ? values.product.sku : '';
    this.returnForeignMeta.productSku = values.product ? values.product.sku : '';

    this.singleMeta.orderId = this.orderId;
    this.returnMeta.orderId = this.orderId;
    const affiliateCode = this.activatedRoute.snapshot.queryParams.affiliate;
    if (affiliateCode && affiliateCode !== '') {
      this.affiliateCode = affiliateCode;
      this.singleMeta.affiliateCode = affiliateCode;
      this.returnMeta.affiliateCode = affiliateCode;
    }
    // console.log('Meta:', this.singleMeta, this.returnMeta);
  }

  buildOrder(values: any): void {
    /**
     * We revert the coupon discount in the order, because the platform does that on it's own terms
     */
    let firstJobPrice = DefaultPrice;
    let secondJobPrice = DefaultPrice;

    if (this.jobPrice) {
      firstJobPrice = JSON.parse(JSON.stringify(this.jobPrice));
      secondJobPrice = JSON.parse(JSON.stringify(this.jobPriceReturn));

      if (this.state.couponDiscount) {
        if (this.state.couponDiscount.discount) {
          firstJobPrice.total = firstJobPrice.total - this.state.couponDiscount.discount;
          firstJobPrice.breakdown.route.total = firstJobPrice.total;
        }

        if (this.state.couponDiscount.discountRetour && values.returnTrip) {
          secondJobPrice.total = secondJobPrice.total - this.state.couponDiscount.discountRetour;
          secondJobPrice.breakdown.route.total = secondJobPrice.total;
        }
      }
    }

    const job: Job = {
      departure: values.departureModel,
      passengerCount: (values.passengerCount ? Number(values.passengerCount) : 1),
      note: values.note,
      vehicleType: (values.product && values.product.vehicleType ? values.product.vehicleType : ''),
      [values.requestedDateMode]: (values[values.requestedDateMode] ? values[values.requestedDateMode] : values.requestedDate),
      language: (this.state.language ? this.state.language.split('-')[0] : 'nl'),
      timezone: (moment(values[values.requestedDateMode]).tz(this.state.timeZone).utcOffset() / 60),
      price: firstJobPrice,
      flightNumber: values.flightNumber,
      couponId: values.couponId,
      passenger: {
        fname: values.firstName,
        lname: values.lastName,
        email: values.email,
        phoneNumber: values.phoneNumber,
        language: (this.state.language ? this.state.language.split('-')[0] : 'nl'),
      },
      meta: JSON.parse(JSON.stringify(this.singleMeta)),
      foreignMeta: {...this.singleForeignMeta, origin: this.formId},
      products: JSON.parse(JSON.stringify(this.singleProducts)),
    };

    if (this.restrictProductsByLuggage) {
      job.luggageCount = Number(values.luggage) || 0;
    }

    if (values.requestedDateMode === 'requestedDestinationDate' && values.requestedDate) {
      job['requestedDate'] = values.requestedDate;
    }

    if (this.passenger) {
      job.passengerId = this.passenger.passengerId;
    }
    if (values.paymentMethod && values.paymentMethod.indexOf('ONACCOUNT') > -1) {
      job.debtorId = values.paymentMethod.split('_')[1];
    }

    if (values.destinationModel) {
      job.destination = values.destinationModel;
    }

    if (values.stopOvers) {
      // Drop empty stopover rows (an added-but-unfilled row keeps its seeded []),
      // otherwise the payload contains stopOvers: [[]].
      job.stopOvers = this.sendableStopOvers(values);
    }
    if (this.state.couponDiscount && this.state.couponDiscount.returnType === 'meta') {
      job.meta.couponId = this.state.couponDiscount.id;
    }

    if (values.product) {
      const vehicleProduct: Product = {
        category: 'vehicleType',
        sku: values.product.sku,
        imageUrl: values.product.imagePath,
        description: values.product.name,
        extraInfo: values.product.extraInfo,
        productId: values.product.productId,
        amount: {
          total: values.product.price.total,
          currency: values.product.price.currency,
          taxPercentage: values.product.price.breakdown.route.taxPercentage,
        }
      };
      if (!job.products) {
        job.products = [];
      }
      job.products.push(vehicleProduct);
    }

    if (this.transactionCosts) {
      let transactionCosts = this.transactionCosts;
      if (values.returnTrip) {
        transactionCosts = Math.ceil(this.transactionCosts / 2);
      }
      const transactionCostProduct: Product = {
        category: 'transactionCosts',
        description: 'transactionCosts',
        sku: 'TRANSACTION_COSTS',
        amount: {
          total: transactionCosts,
          currency: values.product.price.currency,
          taxPercentage: values.product.price.breakdown.route.taxPercentage,
        }
      };
      if (!job.products) {
        job.products = [];
      }
      job.products.push(transactionCostProduct);
    }

    if (this.activeTab === 'hourly') {
      if (job.price.total > 0) {
        job.priceMethod = 'hourlyFixed';
      } else {
        job.priceMethod = 'hourlyMeter';
      }

      job.priceMeta = {
        bookedDuration: (values.duration ? (values.duration * 60 * 60) : 0),
      };
    } else if (!values.product?.price?.total) {
      job.priceMethod = 'meter';
    }

    this.order = {
      paymentMethod: values.paymentMethod,
      jobs: [
        job
      ]
    };

    if (values.returnTrip) {
      let timeMode = values.returnRequestedDateMode;
      const rJob: Job = {
        departure: values.destinationModel,
        passengerCount: (values.passengerCount ? Number(values.passengerCount) : 1),
        note: values.note,
        vehicleType: (values.product && values.product.vehicleType ? values.product.vehicleType : ''),
        language: (this.state.language ? this.state.language.split('-')[0] : 'nl'),
        price: secondJobPrice,
        timezone: (moment(values[values.returnRequestedDateMode]).tz(this.state.timeZone).utcOffset() / 60),
        flightNumber: values.returnFlightNumber,
        couponId: values.couponId,
        passenger: {
          fname: values.firstName,
          lname: values.lastName,
          email: values.email,
          phoneNumber: values.phoneNumber,
          language: (this.state.language ? this.state.language.split('-')[0] : 'nl'),
        },
        meta: JSON.parse(JSON.stringify(this.returnMeta)),
        foreignMeta: {...this.returnForeignMeta, origin: this.formId},
        products: JSON.parse(JSON.stringify(this.returnProducts)),
      };

      if (this.restrictProductsByLuggage) {
        rJob.luggageCount = Number(values.luggage) || 0;
      }

      if (values.returnRequestedDateMode === 'requestedDestinationDate') {
        job['requestedDate'] = values.requestedDate ? values.requestedDate : values[values.returnRequestedDateMode];
      }

      if (values.stopOvers) {
        // Drop empty stopover rows (an added-but-unfilled row keeps its seeded []),
        // otherwise the payload contains stopOvers: [[]]. Reverse for the return leg.
        rJob.stopOvers = JSON.parse(JSON.stringify(this.sendableStopOvers(values))).reverse();
      }

      if (timeMode) {
        rJob[values.returnRequestedDateMode.replace('returnR', 'r')] = (values[timeMode] ? values[timeMode] : null);
      } else if (values['requestedDate']) {
        rJob['requestedDate'] = (values['requestedDate'] ? values['requestedDate'] : null);
      }
      if (this.passenger) {
        rJob.passengerId = this.passenger.passengerId;
      }
      if (values.paymentMethod.indexOf('ONACCOUNT') > -1) {
        rJob.debtorId = values.paymentMethod.split('_')[1];
      }
      if (values.departureModel) {
        rJob.destination = values.departureModel;
      }
      if (values.product) {
        const vehicleProduct: Product = {
          category: 'vehicleType',
          sku: values.product.sku,
          imageUrl: values.product.imagePath,
          description: values.product.name,
          extraInfo: values.product.extraInfo,
          productId: values.product.productId,
          amount: {
            total: values.product.priceReturn.total,
            currency: values.product.priceReturn.currency,
            taxPercentage: values.product.priceReturn.breakdown.route.taxPercentage,
          }
        };
        if (!rJob.products) {
          rJob.products = [];
        }
        rJob.products.push(vehicleProduct);
      }

      if (this.transactionCosts) {
        let transactionCostsReturn = Math.floor(this.transactionCosts / 2);
        const transactionCostProduct: Product = {
          category: 'transactionCosts',
          description: 'transactionCosts',
          sku: 'TRANSACTION_COSTS',
          amount: {
            total: transactionCostsReturn,
            currency: values.product.priceReturn.currency,
            taxPercentage: values.product.priceReturn.breakdown.route.taxPercentage,
          }
        };
        if (!rJob.products) {
          rJob.products = [];
        }
        rJob.products.push(transactionCostProduct);
      }

      if (this.state.couponDiscount && this.state.couponDiscount.returnType === 'meta') {
        job.meta.couponId = this.state.couponDiscount.id;
      }
      if (this.order.jobs) {
        this.order.jobs.push(rJob);
      }
    }
  }

  getQuotation(direction = 'route'): Promise<any> {
    this.loader = true;
    // console.log('this.quotation', this.quotation);
    // if (!this.quotation) {
    const values = this.formGroup.getRawValue();
    // console.log(values);
    this.buildMeta(values);
    this.buildQuotation(values);
    // }
    this.quotation.priceType = this.activeTab;
    this.quotation.calculateReturn = true;
    if (this.supportMode) {
      this.quotation.returnSupportData = true;
    }
    this.supportCalculationData = [];
    this.returnTripSupportData = [];

    const localRequestedDateMode = (direction === 'route' ? 'requestedDateMode' : 'returnRequestedDateMode');

    // Funnel: a price quotation is being requested (fires per request, before the
    // result is known). The paired outcomes are the GTM `quotation` mirror on success
    // and `quotation_failed` on a no-rules/no-price response below.
    this.analytics.umamiEvent('quotation_requested', this.analyticsContext({ direction }));

    return new Promise((resolve, reject) => {
      this.apiService.postCustom('/quotations', this.quotation).subscribe((products) => {
        // Summarise the quotation result for analytics: outcome + per-product prices.
        let quotationResult = 'success';
        if (products && products.error) {
          quotationResult = products.error;
        } else if (Array.isArray(products) && products[0] && products[0].supportData?.errorCode && !products[0].price) {
          quotationResult = products[0].supportData.errorCode;
        }
        const quotationPrices = (Array.isArray(products) ? products : [])
          .filter((p) => p && p.price && p.price.total > 0)
          .map((p) => `${p.name || p.sku || 'product'}=${(p.price.total / 100).toFixed(2)}`)
          .join(';');

        this.analytics.addToDataLayer({
          [DataLayerProperties.Event]: 'Quotation',
          [DataLayerProperties.QuotationDeparture]: this.quotation.departure.internationalAlias,
          [DataLayerProperties.QuotationDestination]: (this.quotation.destination ? this.quotation.destination.internationalAlias : ''),
          [DataLayerProperties.QuotatioPassengers]: this.quotation.passengerCount,
          [DataLayerProperties.QuotationRequestedDate]: this.quotation.requestedDate,
          [DataLayerProperties.QuotationResult]: quotationResult,
          [DataLayerProperties.QuotationPrices]: quotationPrices
        });

        // Negative action: the quotation came back but matched no rules / no prices.
        if (quotationResult !== 'success') {
          this.analytics.umamiEvent('quotation_failed', this.analyticsContext({ reason: quotationResult }));
        }

        if (products && products.error && products.error === 'NO_RULES_MATCHED') {
          reject({
            title: 'error_no_rules_found_title',
            text: this.translate.instant('no_rules_found_text').replace('{routes}', products.suggestedRoutes.map((r) => `${r.departure} - ${r.destination}`).join('</li><li>')),
          });
          return;
        }

        const firstProduct = products[0];
        if (firstProduct && firstProduct.supportData?.errorCode && !firstProduct.price) {
          const errorCode: string = firstProduct.supportData.errorCode;
          reject({
            title: 'error_no_prices_title',
            text: `error_price_${errorCode.toLowerCase()}`
          });
          return;
        }
        if (firstProduct && firstProduct.metrics && this.formGroup.controls[localRequestedDateMode].value === (direction === 'route' ? 'requestedDestinationDate' : 'returnRequestedDestinationDate') && firstProduct.metrics.duration && this.form.config.airportDropOffRecalculatePickupTime) {
          const d = moment(this.formGroup.controls[this.formGroup.controls[localRequestedDateMode].value].value).subtract(Math.round(firstProduct.metrics.duration), 'minutes').toDate();
          let ms = 1000 * 60 * 5; // convert minutes to ms
          let roundedDate = moment(Math.floor(d.getTime() / ms) * ms).format();
          if (direction === 'route') {
            this.formGroup.controls['requestedDate'].setValue(roundedDate);
            this.formGroup.controls['requestedScheduleDate'].setValue('');
          } else {
            this.formGroup.controls['returnRequestedDate'].setValue(roundedDate);
            this.formGroup.controls['returnRequestedScheduleDate'].setValue('');
          }
        } else if (firstProduct && firstProduct.metrics && this.formGroup.controls[localRequestedDateMode].value === (direction === 'route' ? 'requestedDestinationDate' : 'returnRequestedDestinationDate') && firstProduct.metrics.duration && this.form.config.requestedDestinationDateOffset) {
          const d = moment(this.formGroup.controls[this.formGroup.controls[localRequestedDateMode].value].value).subtract(Math.round(this.form.config.requestedDestinationDateOffset), 'minutes').toDate();
          let ms = 1000 * 60 * 5; // convert minutes to ms
          let roundedDate = moment(Math.floor(d.getTime() / ms) * ms).format();

          if (direction === 'route') {
            this.formGroup.controls['requestedDate'].setValue(roundedDate);
            this.formGroup.controls['requestedScheduleDate'].setValue('');
          } else {
            this.formGroup.controls['returnRequestedDate'].setValue(roundedDate);
            this.formGroup.controls['returnRequestedScheduleDate'].setValue('');
          }
        } else if (this.formGroup.controls[localRequestedDateMode].value === (direction === 'route' ? 'requestedScheduleDate' : 'returnRequestedScheduleDate')) {
          this.formGroup.controls[this.formGroup.controls[localRequestedDateMode].value].setValue(this.formGroup.controls[this.formGroup.controls[localRequestedDateMode].value].value);

          if (direction === 'route') {
            this.formGroup.controls['requestedDate'].setValue('');
            if (this.formGroup.controls['requestedDestinationDate']) {
              this.formGroup.controls['requestedDestinationDate'].setValue('');
            }
          } else {
            this.formGroup.controls['returnRequestedDate'].setValue('');
            if (this.formGroup.controls['returnRequestedDestinationDate']) {
              this.formGroup.controls['returnRequestedDestinationDate'].setValue('');
            }
          }
        } else if (this.formGroup.controls[localRequestedDateMode].value === (direction === 'route' ? 'requestedDate' : 'returnRequestedDate')) {
          if (direction === 'route') {
            if (this.formGroup.controls['requestedScheduleDate']) {
              this.formGroup.controls['requestedScheduleDate'].setValue('');
            }
            if (this.formGroup.controls['requestedDestinationDate']) {
              this.formGroup.controls['requestedDestinationDate'].setValue('');
            }
          } else {
            if (this.formGroup.controls['returnRequestedScheduleDate']) {
              this.formGroup.controls['returnRequestedScheduleDate'].setValue('');
            }
            if (this.formGroup.controls['returnRequestedDestinationDate']) {
              this.formGroup.controls['returnRequestedDestinationDate'].setValue('');
            }
          }
        } else {
          const dynamicControlKey = this.formGroup.controls[localRequestedDateMode].value;
          const currentValue = this.formGroup.controls[dynamicControlKey] ? this.formGroup.controls[dynamicControlKey].value : undefined;
          this.formGroup.controls[(direction === 'route' ? 'requestedDate' : 'returnRequestedDate')].setValue('');
          if (this.formGroup.controls[(direction === 'route' ? 'requestedDestinationDate' : 'returnRequestedDestinationDate')]) {
            this.formGroup.controls[(direction === 'route' ? 'requestedDestinationDate' : 'returnRequestedDestinationDate')].setValue('');
          }
          if (this.formGroup.controls[(direction === 'route' ? 'requestedScheduleDate' : 'returnRequestedScheduleDate')]) {
            this.formGroup.controls[(direction === 'route' ? 'requestedScheduleDate' : 'returnRequestedScheduleDate')].setValue('');
          }
          if (this.formGroup.controls[dynamicControlKey]) {
            this.formGroup.controls[dynamicControlKey].setValue(currentValue);
          }
        }

        this.products = products.map(product => {
          const currencyCode = product.price.currency;
          this.state.currency = currencyCode;
          this.state.currencySymbol = this.getCurrencySymbol(currencyCode);
          this.metrics = product.metrics;
          if (product.metrics) {
            this.metrics.durationDesc = Math.ceil(product.metrics.duration);
            //Round product.metrics.distance to 2 decimal places
            product.metrics.distanceDesc = Math.round(product.metrics.distance * 100) / 100;
          }

          if (this.supportMode) {
            product.supportData.price = product.price;
            product.supportData.name = product.name;
            this.supportCalculationData.push(product.supportData);

            if (product.supportDataReturn) {
              product.supportDataReturn.price = product.priceReturn;
              product.supportDataReturn.name = product.name;
              this.returnTripSupportData.push(product.supportDataReturn);
            }
          }

          return {
            ...product,
            'descriptionTag': (product.sku && (!this.form.config.parts[1].productDescription
              || this.form.config.parts[1].productDescription === 'sku')
              ? `product_description_${product.sku.toLowerCase()}` : product.name),
            'summaryTag': `product_summary_${product.sku.toLowerCase()}`,
            'currencySymbol': this.getCurrencySymbol(product.price.currency),
            'imagePath': (product.imagePath ? product.imagePath : `${this.form.config.cdnUrl}/products/${product.sku}.png`),
            'hourlyButton': (this.formGroup.controls['duration'] ? this.translate.instant('product_button_hourly').replace('{x}', this.formGroup.controls['duration'].value) : false)
          };
        });

        this.loader = false;
        if (this.products.length > 0) {
          resolve(1);
        } else {
          console.log('Error from quotation:');
          reject({
            title: 'error_no_products_found_title',
            text: 'error_no_products_found_text'
          });
        }
      }, (error) => {
        console.log('Error from quotation:', error);
        this.analytics.umamiEvent('quotation_failed', this.analyticsContext({
          reason: (error && error.error && error.error.error && error.error.error.name) || 'request_error'
        }));
        if (error && error.error && error.error.error && error.error.error.name === 'NO_ROUTE') {
          reject({
            title: 'error_no_route_found_title',
            text: 'error_no_route_found_text'
          });
        } else {
          reject({
            title: 'error_no_products_found_title',
            text: 'error_no_products_found_text'
          });
        }
      });
    });
  }

  private getCurrencySymbol(code: string): string {
    try {
      const parts: Array<{type: string; value: string}> = (new Intl.NumberFormat(
        this.state.language || 'en',
        { style: 'currency', currency: code, currencyDisplay: 'narrowSymbol' } as any
      ) as any).formatToParts(0);
      return parts.find(p => p.type === 'currency')?.value ?? code;
    } catch {
      return code;
    }
  }

  checkQuotation(): Promise<any> {
    return this.getQuotation('return')
      .then((results) => {
        /**
         * Get total price
         */
        const selectedProduct = this.products.filter((p) => {
          if (this.formGroup.controls['product'].value.productId) {
            return p.productId === this.formGroup.controls['product'].value.productId
          } else {
            return p.sku === this.formGroup.controls['product'].value.sku
          }
        })[0];

        if (selectedProduct && selectedProduct.priceReturn && selectedProduct.totalPrice.total && selectedProduct.totalPrice.total !== this.formGroup.controls['product'].value.totalPrice.total) {
          this.vatPercentage = selectedProduct.price?.vatPercentage || 0;
          this.priceUpdateButton = selectedProduct;

          this.returnSurcharge = (selectedProduct.totalPrice.total > this.formGroup.controls['product'].value.totalPrice.total);

          const modal = this.modalService.getModal('priceUpdate'+this.instanceId);
          this.getPaymentMethodCosts();
          modal.open();
          return Promise.reject();
        }

        // Always sync the form product with the fresh quotation result so that
        // priceReturn (and calculatePricing / jobPriceReturn) reflect any
        // return-trip rule that only became visible after the return date was
        // entered — even when totalPrice.total hasn't changed.
        if (selectedProduct && selectedProduct.priceReturn) {
          this.formGroup.patchValue({ product: selectedProduct });
        }
      })
  }

  selectProduct() {
    this.formGroup.patchValue({
      product: this.priceUpdateButton,
    });
    this.acceptedPrice = true;
    this.navigate('next');
  }

  getSkipQuotation(): Promise<number> {
    return this.getQuotation().then(() => {
      this.formGroup.patchValue({
        'product': this.products[0]
      });
      return Promise.resolve(2);
    })
  }

  getPaymentMethodCosts(selectedProduct = null, selectedProductReturn = null): Promise<any> {
    if (!selectedProduct) {
      selectedProduct = JSON.parse(JSON.stringify(this.selectedProducts[0]));
      selectedProductReturn = JSON.parse(JSON.stringify(this.selectedProducts[1]));
    }

    let singlePrice = this.singlePrice;
    let returnPrice = this.returnPrice;
    if (selectedProduct) {
      singlePrice = selectedProduct.price.total;
    }
    if (selectedProductReturn && this.formGroup.controls.returnTrip.value) {
      returnPrice = selectedProductReturn.priceReturn.total;
    }
    return new Promise((resolve) => {
      const gateways = this.state.paymentGateways;
      gateways.forEach((g, i) => {
        if (g.transactionCosts) {
          gateways[i].calculatedCosts = this.calculateTransactionCosts((singlePrice + returnPrice), g.transactionCosts);
        }
      });
      this.state.paymentGateways = [...gateways];

      this.state.paymentGateways.forEach((method) => {
        if (method.id === this.formGroup.controls.paymentMethod.value) {
          this.transactionCosts = method.calculatedCosts;
        }
      });

      return resolve(3);
    });
  }

  async bookOrder(): Promise<any> {
    const self = this;
    const paymentMethod = this.formGroup.controls.paymentMethod.value;
    // console.log(`bookOrder(${paymentMethod})`);
    this.buildOrder(this.formGroup.getRawValue());
    this.state.orderPosted = true;
    this.saveState();
    this.checkPageValidity();
    if (this.pageStates[this.selectedFormIndex]) {
      this.saveOrder()
        .then(() => {
          if (!this.catchDuplicateBooking && this.orderId) {
            this.catchDuplicateBooking = true;
            setTimeout(function () {
              self.catchDuplicateBooking = false;
            }, 2000);
            // console.log(paymentMethod);``
            // console.log(this.formGroup.controls['product'].value.price);
            // console.log(this.paymentGateways);
            if (this.paymentGateways[paymentMethod].preAuth) {
              const modal = this.modalService.getModal(`paymentPreauthModal${this.instanceId}`);
              modal.open();
            } else if (this.form.config.orderConfirm) {
              const modal = this.modalService.getModal(`orderConfirm${this.instanceId}`);
              modal.open();
            } else if (!this.paymentGateways[paymentMethod].directProcess && this.totalPrice > 0) {
              this.createPayment();
            } else {
              this.processOrder();
            }
          }
        }).catch((error) => {
        // Negative action: saving/creating the order failed before processing.
        self.analytics.umamiEvent('booking_failed', self.analyticsContext({
          stage: 'save',
          reason: (error && error.error && error.error.message) || 'save_error'
        }));
        if (error && error.error && error.error.message) {
          self.showAlert(error.error.message);
        }
        self.loader = false;
      })
    } else {
      /**
       * Not booking because form is not valid
       * - If there is only 1 error, that is the terms error we show a helper dialog
       */
      if (this.errorService.errors.length === 1 && this.errorService.errors[0].id === 'acceptTermsAndConditionsRequired') {
        const modal = this.modalService.getModal(`termsAndConditionsModal${this.instanceId}`);
        modal.addCustomClass('termsAndConditionsModal');
        modal.open();
      }
    }
  }

  acceptTermsAndBook(): void {
    const termsAndConditionsModal = this.modalService.getModal(`termsAndConditionsModal${this.instanceId}`);
    this.formGroup.controls['acceptTermsAndConditions'].setValue(true);
    termsAndConditionsModal.close()
    this.bookOrder();
  }

  saveState(): void {
    const data = this.formGroup.getRawValue();
    data.timesaved = new Date();
    this._vault.setObject(this.state.storageKeys.values, data);
    this._vault.setItem(this.state.storageKeys.orderId, this.orderId);
  }

  clearState(): void {
    // Remember the passenger BEFORE the stored values are wiped: ConfirmationComponent mounts
    // right after this and would only find an empty object (so nothing was ever saved).
    try {
      saveRecentPassenger(this.formGroup.getRawValue());
    } catch { /* never block finishing a booking on this */ }
    this._vault.removeItem(this.state.storageKeys.values);
    this._vault.removeItem(this.state.storageKeys.orderId);
    // Clear the in-memory orderId the moment the booking is finalized. saveOrder()
    // uses this.orderId to choose POST (new) vs PATCH (existing); leaving the
    // processed order's id around lets the NEXT booking PATCH+re-process the old
    // order. The "Book new ride" button also clears it, but the inline widget keeps
    // all steps mounted and retains addresses, so a user can return to step 0 by a
    // path that bypasses that handler (observed on iOS Safari). Resetting here at the
    // source covers every re-booking entry point.
    this.orderId = '';
  }

  saveOrder(): Promise<any> {
    // console.log(`saveOrder(): ${this.orderId}`, this.order);
    const method = (this.orderId ? 'patchCustom' : 'postCustom');
    const path = `/orders${(this.orderId ? `/${this.orderId}` : '')}`;
    // console.log(`Method: ${method}`);
    return this.apiService[method](path, this.order).toPromise().then((order) => {
      // console.log(`Order: ${order}`);
      if (order && order.id) {
        this.orderId = order.id;
      }
      this.saveState();
      return order;
    }, (error) => {
      return Promise.reject(error);
    });
  }

  processOrder(): void {
    const self = this;
    const lang = self.state.language;
    const formId = self.state.formId;
    if (self.form.config.successUrl) {
      self.onlyShowLoader = true;
    }
    self.loader = !self.processingPayment;

    self.apiService.postCustom(`/orders/${self.orderId}/process`, {}).subscribe((processedOrder) => {
      /**
       * RESET JWT-TOKEN
       */
      self._vault.removeItem(self.state.storageKeys.jwtToken);

      self.apiService.getCustom(`/orders/${self.orderId}/payment`, {}).subscribe(payment => {
        self.analytics.addToDataLayer({
          [DataLayerProperties.Event]: 'Booking',
          [DataLayerProperties.AffiliateCode]: self.affiliateCode,
          [DataLayerProperties.TransactionId]: self.orderId,
          [DataLayerProperties.TransactionAffiliation]: formId,
          [DataLayerProperties.TransactionTotal]: (payment ? payment.amount : self.totalPrice) / 100,
          [DataLayerProperties.TransactionCurrency]: self.state.currency,
          // Non-PII context (implementation, vehicleType, trip, passengers, …) is merged in
          // for the Umami event only — GTM keeps just the enum keys. No name/email/phone.
          ...self.analyticsContext(),
        } as any);
        // Skip the Umami page view: `order-processed` is the same funnel step as
        // `booking_completed`, so it would otherwise duplicate that step. (GTM still gets it.)
        self.analytics.pageView(`/${lang}/${formId}/order-processed`, undefined, true);
        self.clearState();

        self.loader = false;
        if (self.form.config.successUrl) {
          return top.location = `${self.form.config.successUrl}?orderId=${processedOrder.id}&language=${lang}${(self.affiliateCode ? `&affiliateCode=${self.affiliateCode}` : '')}`;
        } else if (self.navigation === 'inline' || self.navigation === 'modal' || self.navigation === 'scroll') {
          self.orderStatus = (['processed', 'requested'].includes(processedOrder.status) ? 'completed' : 'failed');
          // self.selectedFormIndex = 4;
          // booking_completed is fired by ConfirmationComponent, which is mounted next as the
          // inline completion step (and also for the routed flow) — see trackTerminalEvents().
          self.navigate('next', 4);
        } else {
          // console.log(`/${lang}/${formId}/${processedOrder.id}/completed`);
          return self.router.navigate([`/${lang}/${formId}/${processedOrder.id}/completed`]);
        }
      }, (error) => {
        console.error(error);
        self.loader = false;
      });
    }, (error) => {
      const alreadyProcessed = error && error.error && error.error.error && error.error.error.message === 'Order already processed';
      if (!alreadyProcessed) {
        // Negative action: processing the order failed ('already processed' is a recoverable
        // success path, so it is excluded).
        self.analytics.umamiEvent('booking_failed', self.analyticsContext({
          stage: 'process',
          reason: (error && error.error && error.error.error && error.error.error.message) || 'process_error'
        }));
      }
      if (alreadyProcessed) {
        self.apiService.getCustom(`/orders/${self.orderId}/`).subscribe((processedOrder) => {
          self.clearState();
          self.loader = false;
          self.processingPayment = false;
          self.state.reset();
          if (self.form.config.successUrl) {
            return top.location = `${self.form.config.successUrl}?orderId=${processedOrder.id}&language=${lang}${(self.affiliateCode ? `&affiliateCode=${self.affiliateCode}` : '')}`;
          } else if (self.navigation === 'inline' || self.navigation === 'modal') {
            self.orderStatus = (['processed', 'requested'].includes(processedOrder.status) ? 'completed' : 'failed');
            // self.selectedFormIndex = 4;
            self.navigate('next', 4);
          } else {
            return self.router.navigate([`/${lang}/${formId}/${processedOrder.id}/completed`]);
          }
        });
      }
      self.loader = false;
      self.processingPayment = false;
    });
  }

  // Whether the "Request a quote" action is offered at all. Single gate point — see
  // QuoteRequestService.isQuotationEnabled() for the (form-level opt-in) contract.
  canRequestQuote(): boolean {
    return QuoteRequestService.isQuotationEnabled(this.form && this.form.config);
  }

  // Builds the QuoteRequestContext QuoteRequestService needs from this component. apiService
  // stays private to OrderComponent (see CLAUDE.md "Services"), so it is only ever read from
  // inside OrderComponent itself, here.
  private quoteRequestContext(): QuoteRequestContext {
    return {
      apiService: this.apiService,
      analytics: this.analytics,
      buildOrder: (values) => this.buildOrder(values),
      saveOrder: () => this.saveOrder(),
      saveState: () => this.saveState(),
      getOrderId: () => this.orderId,
      analyticsContext: (extra) => this.analyticsContext(extra),
    };
  }

  // Alternative to bookOrder(): instead of paying/processing into rides, ask the backend to
  // create a quoted ride + email the customer a link to the dedicated quote/payment page (see
  // QuoteRequestService for the shared buildOrder -> saveOrder -> requestQuote sequence).
  requestQuote(): void {
    const self = this;
    const values = this.formGroup.getRawValue();
    // Set BEFORE the email check (matches the previous behaviour): this also flips on the
    // field-level "required" error display (field-error.component.html), so a missing email
    // gets highlighted on the field itself, not just the alert modal below.
    this.state.orderPosted = true;

    if (!values.email) {
      this.analytics.umamiEvent('quote_failed', this.analyticsContext({stage: 'validate', reason: 'missing_email'}));
      this.showAlert(this.translate.instant('request_quote_email_required'));
      return;
    }

    this.loader = true;
    QuoteRequestService.requestQuote(this.quoteRequestContext(), values).then((result) => {
      self.loader = false;
      if (result.success) {
        const modal = self.modalService.getModal(`quoteRequestedModal${self.instanceId}`);
        if (modal) {
          modal.open();
        }
      } else if (result.errorMessage) {
        self.showAlert(result.errorMessage);
      }
    });
  }

  // Contact-details part (page 3) — the form part that holds the email field. Its
  // fields are rendered inside the product-page quote dialog (bound to the shared
  // formGroup) so the customer can fill them in without leaving the price page.
  // Anchored to a real contact step: the address/products/summary/completion parts
  // are skipped so a stray email-typed field on another page can't be picked up, and
  // we match the canonical `email` control rather than any email-typed field.
  get quoteContactPart(): any {
    const parts = (this.form && this.form.config && this.form.config.parts) || [];
    return parts.find((p: any) =>
      p.type !== 'products' && p.type !== 'summary' && p.type !== 'completion' && p.type !== 'address' &&
      (p.fieldsWithLayoutInfo || p.fields || []).some((f: any) => f.property === 'email')
    ) || null;
  }

  get quoteContactFields(): any[] {
    const part = this.quoteContactPart;
    if (!part) {
      return [];
    }
    return (part.fieldsWithLayoutInfo || part.fields || []).filter((f: any) => !f.hidden);
  }

  // Product page: open the contact-details dialog (triggered by the summary-card button).
  // Use the service open() (not the modal instance method) per the ngx-smart-modal rule
  // in CLAUDE.md — the instance method fires window.dispatchEvent with the data-layout bug.
  openQuoteContact(): void {
    this.modalService.open(`quoteContactModal${this.instanceId}`);
  }

  // Summary page: open the explanatory confirmation dialog before sending.
  openQuoteConfirm(): void {
    this.modalService.open(`quoteConfirmModal${this.instanceId}`);
  }

  // Shared submit path for both quote dialogs: require an email, close the dialog,
  // then send the quotation (requestQuote() shows the success modal on completion).
  submitQuoteFromDialog(modal: any): void {
    const email = this.formGroup.getRawValue().email;
    if (!email) {
      this.showAlert(this.translate.instant('request_quote_email_required'));
      return;
    }
    if (modal) {
      modal.close();
    }
    this.requestQuote();
  }

  createPayment(preAuth = false): void {
    this.loader = true;
    const language = this.activatedRoute.snapshot.paramMap.get('language') ?
      this.activatedRoute.snapshot.paramMap.get('language') :
      (this.activatedRoute.parent && this.activatedRoute.parent.snapshot.paramMap.get('language') ? this.activatedRoute.parent.snapshot.paramMap.get('language') : this.state.language);

    this.mspLanguage = MSP_LOCALES[language];
    const productDescription = this.translate.instant(this.formGroup.controls['product'].value.descriptionTag);
    const d = moment(this.formGroup.controls[this.formGroup.controls.requestedDateMode.value].value).tz(this.state.timeZone);
    const address = (this.formGroup.controls.departure.value && this.formGroup.controls.departure.value.description ? this.formGroup.controls.departure.value.description : this.formGroup.controls.departure.value);
    // Pickup date in the company's configured format (company settings, same on
    // api.dispatchapi.io and api.taxiid.nl); falls back to the previous fixed format.
    const cs = this.state.companySettings || {};
    const dateFormat = cs.dateFormat || 'DD-MM-YYYY';
    const timeFormat = cs.clock === '12' ? 'hh:mm a' : 'HH:mm';
    const description = (preAuth ? this.translate.instant('payment_description_preauth') :
      this.translate.instant('payment_description'))
      .replace('{productname}', productDescription)
      .replace('{date}', d.format(`${dateFormat} ${timeFormat}`))
      .replace('{address}', address);

    const gateway = this.formGroup.controls.paymentMethod.value;
    const psp = this.paymentGateways[gateway]?.provider || (gateway.toUpperCase() === 'STRIPE' ? 'STRIPE' : 'MSP');

    const paymentData = {
      amount: this.totalPrice,
      currency: this.formGroup.controls['product'].value.price.currency,
      provider: this.formGroup.controls.paymentMethod.value,
      gateway: this.formGroup.controls.paymentMethod.value,
      product: {
        description: productDescription,
        sku: this.formGroup.controls['product'].value.sku,
        extraInfo: this.formGroup.controls['product'].value.extraInfo,
        amount: {
          total: this.formGroup.controls['product'].value.price.total,
          currency: this.formGroup.controls['product'].value.price.currency,
          taxPercentage: this.formGroup.controls['product'].value.price.taxPercentage,
        },
        imageUrl: (
          this.formGroup.controls['product'].value.imagePath ? this.formGroup.controls['product'].value.imagePath :
            ((this.form.config.cdnUrl === 'https://order.yourdriverapp.com' ?
              `${this.form.config.cdnUrl}/assets/default-product-img.png` :
              (this.form.config.cdnUrl ?
                `${this.form.config.cdnUrl}/products/${this.formGroup.controls['product'].value.sku}.png` :
                `${this.form.config.customUri}/assets/default-product-img.png`)))),
      },
      description,
      orderId: this.orderId,
      customer: {
        locale: this.mspLanguage,
        ipAddress: this.ipAddress,
        firstName: this.formGroup.controls.firstName.value,
        lastName: this.formGroup.controls.lastName.value,
        emailAddress: this.formGroup.controls.email.value,
        phoneNumber: this.formGroup.controls.phoneNumber.value,
      },
    };
    if (preAuth) {
      // @ts-ignore
      paymentData.preAuth = preAuth;
      // @ts-ignore
      paymentData.submitText = this.translate.instant('preauth_submit_text');
    }
    // console.log(`createPayment(): paymentData`, paymentData);

    this.apiService.postCustom(`/payments`, paymentData)
      .subscribe(payment => {
        this._vault.setObject(this.state.storageKeys.payment, paymentData);
        payment.gateway = this.formGroup.controls.paymentMethod.value;
        this._vault.setObject(this.state.storageKeys.paymentMeta, payment);
        this._vault.setItem(this.state.storageKeys.paymentStarted, '1');
        // The user is being redirected to the PSP to pay — the payment leg of the funnel
        // begins here. payment_completed / payment_failed close it on return (waitForPayment).
        this.analytics.umamiEvent('payment_initiated', this.analyticsContext({
          gateway: this.formGroup.controls.paymentMethod.value,
          provider: psp,
          preAuth,
          transactionId: this.orderId,
        }));
        if (window.top) {
          window.top.location.href = payment.paymentUrl;
        } else {
          window.location.href = payment.paymentUrl;
        }
      }, error => {
        this.loader = false;
        // Negative action: the PSP payment could not be created, so the redirect never happens.
        this.analytics.umamiEvent('payment_failed', this.analyticsContext({
          stage: 'create',
          gateway: this.formGroup.controls.paymentMethod.value,
          provider: psp,
          reason: (error && error.error && (error.error.message || (error.error.error && error.error.error.message))) || 'create_error',
        }));
        console.error(error);
      });
  }

  navigate(direction: string, index: number = -1): void {
    if (!this.form || !this.form.config || !this.form.config.parts || !this.formGroup) {
      return;
    }
    this.buildOrder(this.formGroup.getRawValue())
    const currentType = this.form.config.parts[this.selectedFormIndex].type;
    const indexSpecified = index > -1;
    let newIndex = (indexSpecified ? index : (direction === 'next' ? this.selectedFormIndex + 1 : this.selectedFormIndex - 1));
    const newType = this.form.config.parts[newIndex].type;
    let checkPromise = Promise.resolve();

    if (direction === 'back' && this.form.config.parts[newIndex].before === 'getSkipQuotation') {
      newIndex = newIndex - 1;
    }
    const goingBack = this.selectedFormIndex > newIndex;
    const goingForward = this.selectedFormIndex < newIndex;
    const returnTrip = this.formGroup.controls.returnTrip.value;
    const hasProduct = this.formGroup.controls['product'].value !== null;
    const fn = this.form.config.parts[newIndex].before;
    const afterFn = this.form.config.parts[newIndex].after;

    if (goingForward) {
      this.checkPageValidity();
    }

    if (!this.pageStates[this.selectedFormIndex] && goingForward) {
      console.error('FORM NOT VALID, NOT NAVIGATING!');
    } else {
      if (currentType === 'products' && goingBack && hasProduct) {
        this.formGroup.controls['product'].setValue(null);
        this.formGroup.controls.returnTrip.setValue(false);
        this.pageStates[this.selectedFormIndex] = false;
        this.acceptedPrice = false;

        if (returnTrip) {
          this.selectedFormIndex = 1;
        } else {
          this.selectedFormIndex = newIndex;
        }
      }
      else {
        if (newType === 'products' && goingBack && !returnTrip) {
          this.pageStates[newIndex] = false;
        }
        else if (currentType === 'products' && !goingBack) {
          this.pageStates[newIndex] = false;
          this.processDatesForOrder();

          if (this.formGroup.controls.returnTrip.value && !this.acceptedPrice) {
            checkPromise = this.checkQuotation();
          }
        }
        else if (newType === 'products' && goingBack) {
          this.acceptedPrice = false;
        }

        /**
         * We need to correct the requestedDate setup
         * Are we showing the destinationdate? Then we put it in the requested date
         */
        checkPromise.then(() => {
          if (newIndex === 0 && this.state.orderMode == 'airport' && this.state.airportDestination &&
            this.formGroup.controls['requestedDestinationDate'] && this.formGroup.controls['requestedDestinationDate'].value) {
            this.formGroup.controls['requestedDate'].setValue(this.formGroup.controls['requestedDestinationDate'].value);
          }

          if (fn) {
            this[fn]().then((skipIndex) => {
              this.selectedFormIndex = skipIndex;
              this.scrollUp();
            }, (error) => {
              // Negative action: a before-step (e.g. quotation) failed, blocking navigation.
              this.analytics.umamiEvent('navigation_failed', this.analyticsContext({
                step: this.form.config.parts[newIndex]?.gtmVirtualPageUrl,
                stepIndex: newIndex,
                reason: (error && (error.title || error.message || error.name)) || 'before_step_failed'
              }));
              console.error('ERROR IN BEFORE', error);
              this.navigationError = error;
              this.modalService.open(`navigationErrorModal${this.instanceId}`);
              this.loader = false;
            });
          } else {
            this.selectedFormIndex = newIndex;
            this.scrollUp();
          }

          // GTM keeps the per-step virtual page view; the Umami funnel is driven by a
          // `<step>_loaded` event fired when the user ARRIVES at a step (forward nav only),
          // so the funnel reads form_loaded -> product_selection_loaded -> ... .
          this.analytics.pageView(`/${this.state.language}/${this.form.id}/${this.form.config.parts[newIndex].gtmVirtualPageUrl}`,
            undefined, true, this.analyticsContext({ step: this.form.config.parts[newIndex]?.gtmVirtualPageUrl, stepIndex: newIndex }));
          if (goingForward) {
            this.emitStepLoaded(newIndex);
          }

        }).catch((error) => {
        });
      }
    }
  }

  processDatesForOrder() {
    let mode = this.formGroup.controls['returnRequestedDateMode'].value.replace('request', 'returnRequest');
    if (this.metrics && this.formGroup.controls['returnRequestedDateMode'].value === 'requestedDestinationDate' && this.metrics.duration && this.form.config.airportDropOffRecalculatePickupTime) {
      const d = moment(this.formGroup.controls[mode].value).subtract(Math.round(this.metrics.duration), 'minutes').toDate();
      let ms = 1000 * 60 * 5; // convert minutes to ms
      let roundedDate = moment(Math.ceil(d.getTime() / ms) * ms).format();
      this.formGroup.controls['returnRequestedDate'].setValue(roundedDate);
      // console.log('Calculated returnRequestedDate:', this.formGroup.controls['returnRequestedDate'].value);
    } else if (mode === 'requestedScheduleDate') {
      // console.log(this.formGroup.controls[mode].value);
      this.formGroup.controls['returnRequestedDate'].setValue(this.formGroup.controls[mode].value);
    } else if (mode === 'returnRequestedDate') {
      if (this.formGroup.controls['returnRequestedScheduleDate']) {
        this.formGroup.controls['returnRequestedScheduleDate'].setValue('');
      }
      if (this.formGroup.controls['returnRequestedDestinationDate']) {
        this.formGroup.controls['returnRequestedDestinationDate'].setValue('');
      }
    }
  }

  scrollUp(): void {
    setTimeout(() => {
      window.scroll({
        behavior: 'smooth',
        left: 0,
        top: 0
      });
    }, 100);
  }

  detectGoogleMapsLoaded() {
    const self = this;
    if (!this.googleMapsLoaded) {
      if (typeof (google) !== 'undefined') {
        this.googleMapsLoaded = true;
      } else {
        setTimeout(function () {
          self.detectGoogleMapsLoaded();
        }, 1000);
      }
    }
  }

  closeNavigationError() {
    this.modalService.close(`navigationErrorModal${this.instanceId}`);
  }

  /**
   * The app's own alert — reuses `navigationErrorModal` (the same modal a failed
   * navigation step already shows). Never use the native browser `alert()`: it
   * blocks all page scripting/events until dismissed and looks broken embedded
   * in a customer's own website.
   */
  protected showAlert(text: string, title = 'form_alert_title'): void {
    this.navigationError = {title, text};
    this.modalService.open(`navigationErrorModal${this.instanceId}`);
  }

  toggleHelpModal(event: any) {
    this.helpData.helpTitleTag = event.helpTitleTag || 'help_title_tag_unknown';
    this.helpData.helpTextTag = event.helpTextTag || 'help_text_tag_unknown';
    this.helpData.meta = event.meta || null;
    const type = (event.type ? event.type : 'helpModal');
    const modal = this.modalService.getModal(type+''+this.instanceId);
    modal.addCustomClass(type);
    if (type === "serviceAreaModal" && this.serviceArea) {
      if (!this.myPolygon) {
        this.myPolygon = new google.maps.Polygon({
          paths: [this.serviceArea],
          strokeColor: this.form.config.styles.colors['global-title-color'],
          strokeOpacity: 1,
          strokeWeight: 1,
          fillColor: this.form.config.styles.colors['global-title-color'],
          fillOpacity: 0.2,
          zIndex: 1
        });
      }

      this.departureMarker = {
        draggable: false,
        clickable: false,
        icon: {
          url: 'assets/icon-location-departure.svg',
          scaledSize: new google.maps.Size(30, 30),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(15, 15)
        }
      };
      this.destinationMarker = {
        draggable: false,
        clickable: false,
        icon: {
          url: 'assets/icon-location-destination.svg',
          scaledSize: new google.maps.Size(30, 30),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(15, 15)
        }
      };
      this.modalService.open(type + '' + this.instanceId);
    } else {
      this.modalService.open(type + '' + this.instanceId);
    }
  }

  serviceAreaMapFitBounds(attempt = 0) {
    if (attempt > 20) return; // give up after ~5s to prevent infinite retry if modal closes early
    if (this.serviceAreaMap) {
      if (this.serviceAreaMap.googleMap) {
        google.maps.event.trigger(this.serviceAreaMap.googleMap, 'resize');
      }
      // Defer fitBounds so the map can process the resize event first
      setTimeout(() => {
        if (!this.serviceAreaMap) return;
        const bounds = getBounds([this.myPolygon]);
        if (this.formGroup.controls.departureModel.value) {
          bounds.extend(new google.maps.LatLng(this.formGroup.controls.departureModel.value.gps));
        }
        if (this.formGroup.controls.destinationModel.value) {
          bounds.extend(new google.maps.LatLng(this.formGroup.controls.destinationModel.value.gps));
        }
        this.serviceAreaMap.fitBounds(bounds);
      }, 100);
    } else {
      setTimeout(() => this.serviceAreaMapFitBounds(attempt + 1), 250);
    }
  }

  ngOnDestroy(): void {
    if (this.formChanges) {
      this.formChanges.unsubscribe();
    }
    if (this.formSubscription) {
      this.formSubscription.unsubscribe();
    }
    if (this.errorSubscription) {
      this.errorSubscription.unsubscribe();
    }
    if (this.ipAddressSubscription) {
      this.ipAddressSubscription.unsubscribe();
    }
    if (this.contractTypeSubscription) {
      this.contractTypeSubscription.unsubscribe();
    }
    if (this.googleApiWarningSubscription) {
      this.googleApiWarningSubscription.unsubscribe();
    }
  }

  setActivateTab(tab): void {
    const self = this;
    if (!this.form.config.parts || !this.form.config.parts[0] || !this.form.config.parts[0].fields) {
      setTimeout(function () {
        self.setActivateTab(tab);
      }, 50);
    } else {
      this.activateTab(tab);
    }
  }

  activateTab(tab: string): void {
    if (this.activeTab === tab) return;

    this.activeTab = tab;
    this.form.config.orderType = tab;

    const fields = this.form.config.parts[0].fieldsWithLayoutInfo;

    // 🔍 Find all address indices
    const addressIndices = fields
      .map((f, i) => (f.type === 'address' || f.type === 'sortable-address') ? i : -1)
      .filter(i => i !== -1);

    // 🧹 Remove any existing durationConfig
    const existingDurationIndex = fields.findIndex(f => f === this.durationConfig);
    if (existingDurationIndex !== -1) {
      fields.splice(existingDurationIndex, 1);
    }

    if (tab === 'hourly') {
      // 💾 Save destinationConfig if we haven't yet
      if (!this.destinationConfig) {
        const firstAddressIndex = fields.findIndex(f => f.type === 'address');
        if (firstAddressIndex !== -1) {
          this.destinationConfig = fields[firstAddressIndex];
        }
      }

      // Hide the destination field only when this tab has no destination row of its own: with
      // stopovers enabled the sortable address list keeps managing it. Hiding and restoring must
      // stay outside the stopover condition — stopovers can now be on for one booking type and
      // off for the other, and a hide that its restore no longer matches would leave the field
      // typed 'hidden' for the rest of the session (it would then also be missing from the
      // summary, which renders an address only for the 'address'/'hiddenInputAddress' types).
      if (!this.stopOversAllowedOn(tab) && !this.form.config.bookingHourlyDestination) {
        // console.log("🧹 Remove any existing destinationConfig");
        const existingDestinationIndex = fields.findIndex(f => f === this.destinationConfig);
        if (existingDestinationIndex !== -1) {
          if (!this.destinationTypeBeforeHide) {
            this.destinationTypeBeforeHide = fields[existingDestinationIndex].type;
          }
          fields[existingDestinationIndex].type = 'hidden';
        }
      }

      // ➕ Insert durationConfig after last address
      const insertIndex = addressIndices.length ? addressIndices[addressIndices.length - 1] + 1 : fields.length;
      fields.splice(insertIndex, 0, this.durationConfig);
    } else {
      // 🧹 No durationConfig in non-hourly — only undo the hide above, which is a no-op when
      // the field was never hidden.
      const existingDestinationIndex = fields.findIndex(f => f === this.destinationConfig);
      if (existingDestinationIndex !== -1) {
        fields[existingDestinationIndex].type = this.destinationTypeBeforeHide || 'address';
      }
    }

    this.clearStopOversIfDisallowed(tab);

    //console.log('🧠 Updated field through activeTab config:', fields.map(f => f.type));
  }

  /**
   * Options for the RideBits-style trip-type selector (first step). Derived from the form's
   * capabilities so we never show a mode the form can't handle. Airport arrival/departure are
   * only offered when the form explicitly exposes them (config.airportBookings), otherwise omitted.
   * Each option maps onto the existing route/hourly booking modes via activateTab().
   */
  get serviceTypes(): { id: string; tab: string; icon: string; name: string; sub: string }[] {
    if (!this.form || !this.form.config) { return []; }
    const cfg = this.form.config;
    const options = [];
    if (cfg.airportBookings && cfg.routeBookings) {
      options.push({
        id: 'airport-arrival', tab: 'route', icon: 'plane-arrival',
        name: 'service_airport_arrival_title', sub: 'service_airport_arrival_text'
      });
      options.push({
        id: 'airport-departure', tab: 'route', icon: 'plane-departure',
        name: 'service_airport_departure_title', sub: 'service_airport_departure_text'
      });
    }
    if (cfg.routeBookings) {
      options.push({
        id: 'oneway', tab: 'route', icon: 'map-marker',
        name: 'service_oneway_title', sub: 'service_oneway_text'
      });
    }
    if (cfg.hourlyBookings) {
      options.push({
        id: 'hourly', tab: 'hourly', icon: 'clock',
        name: 'service_hourly_title', sub: 'service_hourly_text'
      });
    }
    return options;
  }

  /** Pick a trip type from the selector, switch the form to that mode, then reveal the form. */
  selectService(service: { id: string; tab: string }): void {
    this.activateTab(service.tab);
    this.form.config.orderSubType = service.id;
    this.showServiceSelector = false;
  }

  closeModal = () => {
    const self = this;
    setTimeout(() => {
      self.formGroup.controls['product'].setValue(null);
      self.formGroup.controls.returnTrip.setValue(false);
      self.pageStates[this.selectedFormIndex] = false;
      self.selectedFormIndex = 0;
    }, 400);
  }
  returnSurcharge: any;

  sendReport() {
    this.toggleHelpModal({
      'helpTitleTag': this.translate.instant('support-report-title'),
      'helpTextTag': this.supportFrame.nativeElement.innerHTML,
      'type': 'supportReportModal'
    });
  }

  copyAndClose(containerid) {
    const modal = this.modalService.getModal('supportReportModal'+this.instanceId);
    modal.close();
    let r = document.createRange();
    r.selectNode(document.getElementById(containerid));
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(r);
    document.execCommand("copy");
    window.getSelection().removeAllRanges();
  }

  checkWorkAreas(property): void {
    // address.direction = this.config.property;
    const addresses = {
      destination: this.formGroup.controls.destinationModel.value,
      departure: this.formGroup.controls.departureModel.value,
      onlyWithinSameWorkarea: this.form.config.onlyWithinSameWorkarea || 'either'
    };
    /**
     * Do we have an GPS position for both locations?
     */
    if (!addresses.destination || !addresses.departure ||
      !addresses.destination.gps || !addresses.departure.gps) {
      return;
    }

    this.apiService.postCustom('/forms/validateWorkarea', addresses).subscribe((result) => {
      // Negative action: the trip falls outside the allowed work area. Fire once per
      // response (non-PII — reason only, plus the trip context from analyticsContext).
      const workAreaRejected = result && (
        ((!result.isWorkarea) && result.area) ||
        (typeof result.allowedDeparture !== 'undefined' && (!result.allowedDeparture || !result.allowedDestination))
      );
      if (workAreaRejected) {
        const reason = (this.form.config.onlyWithinSameWorkarea === 'both')
          ? 'both_required'
          : (!result.isWorkarea ? 'not_in_area' : 'area_not_allowed');
        this.analytics.umamiEvent('workarea_failed', this.analyticsContext({ reason }));
      } else {
        // Happy flow: the address(es) passed the work-area check.
        this.analytics.umamiEvent('workarea_validated', this.analyticsContext());
      }
      const hasSortableAddress = (this.wrappers.toArray().filter((w: any) => {
        return (w.field.type === `sortable-address`);
      }).length > 0);
      this.wrappers.toArray().filter((w: any) => {
        return ((w.field.property === property && !hasSortableAddress) || w.field.type === `sortable-address`);
      }).forEach((wrapper: any) => {
        if (!result.isWorkarea && result.area && result.area.coordinates) {
          this.serviceArea = result.area.coordinates[0].map((c) => {
            return {
              lat: c[1],
              lng: c[0]
            };
          });
          this.serviceAreaError = true;
          // When the form requires BOTH pickup and dropoff inside the service area,
          // the generic "either pickup or dropoff" wording is misleading. Use a
          // both-specific message. helpText stays as the work-area key so the
          // "Show area" link and modal keep working.
          const workAreaText = (this.form.config.onlyWithinSameWorkarea === 'both')
            ? 'address_field_error_work_area_both'
            : 'address_field_error_work_area';
          wrapper.addError({
            id: `departureWorkArea`,
            property: 'departure',
            text: workAreaText,
            helpText: 'address_field_error_work_area',
            label: wrapper.field.label
          });
          wrapper.addError({
            id: `destinationWorkArea`,
            property: 'destination',
            text: workAreaText,
            helpText: 'address_field_error_work_area',
            label: wrapper.field.label
          });
        } else if (typeof (result.allowedDeparture) !== 'undefined' && (!result.allowedDeparture || !result.allowedDestination)) {
          this.serviceAreaError = true;
          if (!result.allowedDeparture) {
            wrapper.addError({
              id: `departureWorkArea`,
              property: 'departure',
              text: 'address_field_error_area_not_allowed',
              helpText: 'address_field_error_area_not_allowed',
              label: wrapper.field.label
            });
          }

          if (!result.allowedDestination) {
            wrapper.addError({
              id: `destinationWorkArea`,
              property: 'destination',
              text: 'address_field_error_area_not_allowed',
              helpText: 'address_field_error_area_not_allowed',
              label: wrapper.field.label
            });
          }
        } else {
          this.serviceAreaError = false
          wrapper.removeError({
            id: `departureWorkArea`,
            property: 'departure',
          });
          wrapper.removeError({
            id: `destinationWorkArea`,
            property: 'destination',
          });
        }
      });
    });
  }

  waitForPayment(itterator = 0): void {
    const self = this;
    let transactionId='';
    let paymentStatus='';
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['transaction_id']) {
        transactionId = params['transaction_id'];
        paymentStatus = params['status'];
      }
      if (params['token']) {
        transactionId = params['token'];
      }

      const checkPaymentStatus = (txId: string) => {
        self.apiService.getCustom(`/orders/${self.orderId}/payment/status?transactionId=${txId}&paymentStatus=${paymentStatus}`).subscribe((payment) => {
          if (itterator > 20) {
            self.processingPayment = false;
            // Timed out: route to the failed confirmation screen, which fires payment_failed
            // (the terminal payment/booking events all live in ConfirmationComponent).
            return self.router.navigate([`/${self.state.language}/${self.state.formId}/${self.orderId}/failed`]);
          }

          if (payment.status === 'processing') {
            setTimeout(function () {
              itterator = itterator + 1;
              self.waitForPayment(itterator);
            }, (itterator > 10 ? 2500 : 500));
          } else {
            self.processingPayment = false;
            // Terminal payment_completed / payment_failed / booking_completed are all emitted by
            // ConfirmationComponent (mounted inline at the completion step AND on the routed
            // /completed | /failed pages), so they fire exactly once per booking. It reads the
            // outcome from `status` + the stored payment meta — see trackTerminalEvents().
            if (self.form.config.successUrl) {
              return top.location = self.form.config.successUrl;
            } else if (self.navigation === 'inline' || self.navigation === 'modal' || self.navigation === 'scroll') {
              self.orderStatus = payment.status;
              self.selectedFormIndex = 4;
            } else {
              return self.router.navigate([`/${self.state.language}/${self.state.formId}/${self.orderId}/completed`]);
            }
          }
        });
      };

      if (!transactionId) {
        self.apiService.getCustom(`/orders/${self.orderId}`).subscribe((order) => {
          checkPaymentStatus(order.paymentId || '');
        });
      } else {
        checkPaymentStatus(transactionId);
      }
    });
  }
}
